// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.reported-flow-dialog {
  width: 100%;
  max-width: 480px; /* Match mobile viewflow width */
  max-height: 90vh;
  padding: 0;
  margin: 0 auto;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow-y: auto;
  overflow-x: visible;
  display: flex;
  flex-direction: column;
}
.reported-flow-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}
.reported-flow-dialog .dialog-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
}
.reported-flow-dialog .dialog-header .close-btn {
  color: #64748b;
}
.reported-flow-dialog .dialog-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}
.reported-flow-dialog .dialog-content .view-flow {
  min-height: auto !important;
  background: transparent !important;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #f6f7f8 8%,
    #eceef1 18%,
    #f6f7f8 33%
  );
  width: 100%;
  background: #efeeee;
  padding: 0;
  margin: 0;
  min-height: auto;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .container1 {
  max-width: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .container1 .flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .container1 .flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  max-width: 100%;
  margin: 0;
  padding: 12px;
  background: transparent;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .container1 .flow-layout-container .flow-main-content {
  width: 100%;
  max-width: 100%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text,
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-avatar,
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-icon,
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-image {
  background-image: var(--skeleton-gradient);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s linear infinite, skeleton-pulse 2s ease-in-out infinite;
  background-color: #e0e0e0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text {
  border-radius: 4px;
  height: 16px;
  margin: 6px 0;
  display: block;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-title {
  height: 24px;
  width: 60%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-subtitle {
  height: 16px;
  width: 40%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-badge-text {
  height: 14px;
  width: 80px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.short {
  width: 40%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-description {
  height: 14px;
  width: 100%;
  margin: 8px 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-description.short {
  width: 70%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-action-text {
  height: 14px;
  width: 60px;
  margin: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-text.skeleton-step-title {
  height: 24px;
  width: 70%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-avatar.skeleton-channel-avatar {
  width: 48px;
  height: 48px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 8px;
  flex-shrink: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-icon.skeleton-share-icon {
  width: 20px;
  height: 20px;
  margin-left: auto;
  margin-right: 0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-image {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--skeleton-gradient);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s linear infinite, skeleton-pulse 2s ease-in-out infinite;
  background-color: #e0e0e0;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-image.large {
  padding-bottom: 56.25%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  width: 100%;
  box-sizing: border-box;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-flow-header {
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 12px 8px 12px;
  margin-bottom: 8px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-flow-header .video-title-sticky {
  height: 28px;
  width: 60%;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-info-panel {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .skeleton-info-panel .info-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 20px;
  flex-shrink: 0;
  min-width: 80px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .metadata-skeleton .step-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .metadata-skeleton .step-header .step-header-main {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .metadata-skeleton .video-actions-bar .action-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .metadata-skeleton .video-actions-bar .action-buttons .skeleton-action-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .channel-info-section .channel-header .channel-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .description-section .description-header {
  margin-bottom: 12px;
}
.reported-flow-dialog .dialog-content .skeleton-viewflow-container .description-section .description-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.reported-flow-dialog .dialog-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 24px 24px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

/* (No extra reported-flow metadata overrides; we now reuse viewflow styles
   for .video-metadata and .video-actions-bar to match mobile UI exactly.) */
.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 360px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

* {
  padding: 0px;
  margin: 0px;
}

body {
  background: #efeeee;
  counter-reset: my-sec-counter;
}

.reported-flow-dialog .view-flow {
  background: transparent !important;
  min-height: auto !important;
  padding-top: 0 !important;
}
.reported-flow-dialog .view-flow .container1 {
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container {
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 12px !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 12px !important;
  background: transparent !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-grid .flow-sidebar {
  display: none !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  /* Make flow-info-panel in the admin modal match the video-actions-bar scroll behavior exactly */
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-title-sticky {
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  word-break: normal !important;
  white-space: normal !important;
  display: flex !important;
  flex-direction: row !important;
  border-radius: 0 !important;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04) !important;
  border-bottom: 1px solid #e0e0e0 !important;
  padding: 16px 0 8px 0 !important;
  margin-bottom: 8px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-title-sticky {
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  word-break: normal !important;
  white-space: normal !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  /* Match video-actions-bar scroll behavior exactly */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  flex-direction: row;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
}
@media (max-width: 1024px) {
  .reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel {
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: none;
  }
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  direction: ltr;
  transform: none;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #0f0f0f;
  border-color: #5ea1d8;
  writing-mode: horizontal-tb;
  text-orientation: mixed;
  transform: none;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge.active .info-icon,
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge.active .info-label,
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge.active .info-step-title {
  color: #0f0f0f;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .flow-info-panel .info-badge .info-step-title {
  font-size: 12px;
  color: #606060;
  margin-left: 4px;
  font-weight: 400;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata {
  width: 100% !important;
  padding: 16px 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin-bottom: 16px !important;
  border-bottom: 1px solid #e0e0e0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .step-header {
  display: flex !important;
  align-items: flex-start !important;
  gap: 16px !important;
  margin-bottom: 12px !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .step-header .step-header-main {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  flex: 1 !important;
  min-width: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-title {
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 28px !important;
  color: #0f0f0f !important;
  margin: 0 !important;
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  word-break: normal !important;
  white-space: normal !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar {
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 0 16px 12px 16px !important;
  margin-top: 20px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 4px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-wrap: nowrap !important;
  width: max-content !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex: 0 0 auto !important;
  min-width: 100px !important;
  padding: 6px 10px !important;
  border-radius: 14px !important;
  background: #f2f2f2 !important;
  cursor: pointer !important;
  transition: background 0.2s !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item:hover {
  background: #e5e5e5 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  margin: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item span {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #212427 !important;
  white-space: nowrap !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item .favorite-toggle-icon {
  color: #000000 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item .favorite-toggle-icon.liked {
  color: #ff4d4d !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section {
  width: 100% !important;
  padding: 16px 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin-bottom: 16px !important;
  border-bottom: 1px solid #e0e0e0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}
@media (max-width: 768px) {
  .reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header {
    gap: 12px !important;
    align-items: flex-start !important;
  }
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-avatar img {
  width: 48px !important;
  height: 48px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  cursor: pointer !important;
}
@media (max-width: 768px) {
  .reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-avatar img {
    width: 40px !important;
    height: 40px !important;
  }
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-avatar .material-icons {
  font-size: 48px !important;
  width: 48px !important;
  height: 48px !important;
  color: #606060 !important;
  cursor: pointer !important;
}
@media (max-width: 768px) {
  .reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-avatar .material-icons {
    font-size: 40px !important;
    width: 40px !important;
    height: 40px !important;
  }
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details {
  flex: 1 !important;
  min-width: 0 !important;
  max-width: 100% !important;
  text-align: left !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  cursor: pointer !important;
  margin-bottom: 4px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  width: 100% !important;
  text-align: left !important;
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  word-break: normal !important;
  align-self: flex-start !important;
}
@media (max-width: 768px) {
  .reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details .channel-name {
    font-size: 15px !important;
    margin-bottom: 6px !important;
  }
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 8px !important;
  flex-wrap: wrap !important;
  font-size: 14px !important;
  color: #606060 !important;
  line-height: 1.4 !important;
  margin-top: 2px !important;
  width: 100% !important;
  text-align: left !important;
  align-self: flex-start !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta span {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  white-space: nowrap !important;
  line-height: 1.4 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section {
  width: 100% !important;
  padding: 16px !important;
  background: #f9f9f9 !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  margin-bottom: 16px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .description-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  margin-bottom: -16px !important;
  position: relative !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .description-header h3 {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  flex: 1 !important;
  writing-mode: horizontal-tb !important;
  text-orientation: mixed !important;
  word-break: normal !important;
  white-space: normal !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .description-content {
  margin-top: 16px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .description-content .description-collapsed {
  max-height: 60px !important;
  overflow: hidden !important;
  transition: max-height 0.3s ease !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .description-content > div:not(.description-collapsed) {
  max-height: none !important;
  overflow: visible !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .show-more-button {
  margin-top: 8px !important;
  background: none !important;
  border: none !important;
  color: #606060 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  padding: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .description-section .show-more-button:hover {
  color: #0f0f0f !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content app-customer-feedback-section {
  width: 100% !important;
  padding: 0 !important;
  display: block !important;
  margin-top: 0 !important;
  margin-bottom: 16px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section {
  width: 100% !important;
  padding: 16px 0 !important;
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin-bottom: 16px !important;
  margin-top: 0 !important;
  display: block !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section h3 {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  margin-bottom: 24px !important;
  margin-top: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section {
  display: flex !important;
  gap: 16px !important;
  margin-bottom: 32px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-avatar {
  flex-shrink: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-avatar img {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-avatar .material-icons {
  font-size: 40px !important;
  width: 40px !important;
  height: 40px !important;
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper {
  flex: 1 !important;
  position: relative !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper form {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input {
  flex: 1 !important;
  padding: 8px 0 !important;
  border: none !important;
  border-bottom: 1px solid #e0e0e0 !important;
  font-size: 14px !important;
  color: #0f0f0f !important;
  background: transparent !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input:focus {
  outline: none !important;
  border-bottom-color: #5ea1d8 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input::placeholder {
  color: #909090 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn {
  flex-shrink: 0 !important;
  background: transparent !important;
  border: none !important;
  color: #5ea1d8 !important;
  cursor: pointer !important;
  padding: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50% !important;
  transition: all 0.2s !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:hover:not(:disabled) {
  background: #f0f0f0 !important;
  color: #4a8fc4 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn mat-icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-login-prompt {
  padding: 16px !important;
  background: #f9f9f9 !important;
  border-radius: 8px !important;
  text-align: center !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-login-prompt p {
  margin: 0 !important;
  font-size: 14px !important;
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-login-prompt p a {
  color: #5ea1d8 !important;
  cursor: pointer !important;
  text-decoration: none !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comment-login-prompt p a:hover {
  text-decoration: underline !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list {
  margin-top: 24px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item {
  display: flex !important;
  flex-direction: column !important;
  padding: 16px 0 !important;
  border-bottom: 1px solid #e0e0e0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item:last-child {
  border-bottom: none !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  margin-bottom: 8px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-img {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-icon {
  font-size: 40px !important;
  width: 40px !important;
  height: 40px !important;
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-author-name {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  font-family: "Raleway", sans-serif !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-date {
  font-size: 12px !important;
  color: #606060 !important;
  font-family: "Raleway", sans-serif !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-text {
  font-size: 14px !important;
  line-height: 20px !important;
  color: #0f0f0f !important;
  margin-bottom: 8px !important;
  font-family: "Raleway", sans-serif !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
  flex-wrap: nowrap !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  -ms-overflow-style: none !important;
  scrollbar-width: thin !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar {
  height: 6px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  background: transparent !important;
  border: none !important;
  cursor: pointer !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  transition: background 0.2s !important;
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn:hover {
  background: #f0f0f0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn.liked {
  color: #ff4d4d !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn .like-count {
  font-size: 12px !important;
  font-weight: 500 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .no-comments {
  padding: 32px 16px !important;
  text-align: center !important;
  color: #606060 !important;
  font-size: 14px !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .comments-section .no-comments p {
  margin: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .flow-layout-container .flow-main-content .video-player-section {
  width: 100% !important;
  padding: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile {
  margin-top: 24px !important;
  padding-top: 24px !important;
  border-top: 1px solid #e0e0e0 !important;
  width: 100% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile h2 {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  margin-bottom: 16px !important;
  margin-top: 0 !important;
  display: block !important;
  visibility: visible !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendations-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  overflow-x: hidden !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-item {
  display: flex !important;
  gap: 12px !important;
  cursor: pointer !important;
  padding: 12px !important;
  border-radius: 8px !important;
  transition: background 0.2s !important;
  overflow: hidden !important;
  background: #f9f9f9 !important;
  border: none !important;
  visibility: visible !important;
  opacity: 1 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-item:hover {
  background: #f0f0f0 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-thumbnail {
  flex-shrink: 0 !important;
  width: 168px !important;
  height: 94px !important;
  border-radius: 4px !important;
  overflow: hidden !important;
  background: #000 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-thumbnail img, .reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-thumbnail video {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info {
  flex: 1 !important;
  min-width: 0 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info .recommendation-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #0f0f0f !important;
  margin: 0 0 4px 0 !important;
  line-height: 20px !important;
  white-space: normal !important;
  word-break: break-word !important;
  overflow: hidden !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info .recommendation-meta {
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
  font-size: 12px !important;
  color: #606060 !important;
  flex-wrap: wrap !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090 !important;
}
.reported-flow-dialog .view-flow .container1 .recommendations-section-mobile .recommendation-info .recommendation-price {
  display: block !important;
  margin-top: 4px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #e83e8c !important;
}

.reported-flow-dialog .recommendations-section-mobile {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
}

.view-flow {
  background: #efeeee;
  min-height: 89vh;
  padding-top: 10px;
  /*description wrapper starts here*/
}
.view-flow .container1 {
  max-width: 1040px;
  margin: 0px auto;
  background: transparent;
  padding-bottom: 30px;
  padding: 0px 40px 20px;
}
.view-flow .container1 .user-sec {
  display: flex;
  padding: 20px 20px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px;
  position: relative;
}
.view-flow .container1 .user-sec .user-details {
  flex: 1;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .user-ico {
  flex: 1;
  display: none !important;
}
.view-flow .container1 .user-sec .user-details .user-ico img {
  width: 180px !important;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  max-width: 200px;
}
.view-flow .container1 .user-sec .user-details .ico-details {
  flex: 4;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}
.view-flow .container1 .user-sec .user-details .ico-details p {
  margin-bottom: 20px !important;
  margin-top: 0px !important;
  justify-content: flex-end !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
  max-width: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div {
  width: auto;
  margin-right: 20px;
  display: block;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span {
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span .mat-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 18px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .u-ico {
  margin-right: 15px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode span {
  font-weight: 400 !important;
  color: #212427;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic p {
  margin: 0px !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic > div:last-child {
  margin-right: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic img {
  border-radius: 50%;
  cursor: pointer;
}
.view-flow .container1 .user-sec .user-details .ico-details .like {
  max-width: 100%;
  margin-bottom: 0px;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul {
  max-width: 500px;
  width: 100%;
  display: flex;
  margin-left: -17px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li {
  height: 100%;
  justify-content: flex-start;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
  font-size: 25px;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  margin-bottom: 5px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
  font-size: 10px;
  font-family: "Raleway";
  font-weight: 600;
  text-align: center;
  color: #212427 !important;
  padding: 0px !important;
  min-height: 30px;
  margin-left: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like div {
  flex: 1;
  text-align: right;
}
.view-flow .container1 .viewflow-step {
  width: calc(100% - 40px);
  display: flex;
  padding: 20px 10px 20px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  position: relative;
  border-radius: 10px;
  flex-wrap: wrap;
  background: #fff;
  margin: 10px 20px 10px 20px;
}
.view-flow .container1 .viewflow-step .des-item {
  border-radius: 0px;
  border-right: none;
  max-width: 100%;
  flex-basis: 100%;
  padding-right: 0;
  margin-right: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}
.view-flow .container1 .viewflow-step .des-item .des {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px;
  flex: 1;
  border: 1px solid #ddd;
  border: 0px !important;
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  box-shadow: none !important;
}
.view-flow .container1 .viewflow-step .des-item .des > div {
  flex: none;
  color: #212427;
  display: flex;
  flex-wrap: wrap;
}
.view-flow .container1 .viewflow-step .des-item .des p {
  max-height: 287px;
  padding-right: 10px;
}
.view-flow .container1 .viewflow-step .des-item .des .s-num {
  font-size: 16px;
  width: 30px;
  height: 30px;
  color: #fff;
  border: 0px solid #f3f3f3;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  font-family: "Raleway";
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
.view-flow .container1 .viewflow-step .des-item .des .s-num:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 0px;
  top: 0px;
  position: absolute;
  background: lightgray;
  z-index: -1;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn {
  display: flex;
  align-items: center;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div {
  flex: 1;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div:first-child {
  justify-content: flex-start;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div:last-child {
  justify-content: right;
  text-align: end;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn .lock {
  display: flex;
  align-items: center;
  font-family: "Raleway";
}
.view-flow .container1 .viewflow-step .des-item .btm-btn .lock > span {
  display: flex;
  align-items: center;
}
.view-flow .container1 .viewflow-step .step-sec {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px 0px 0px;
  margin-left: 10px;
  width: 50%;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 40px;
}
.view-flow .container1 .viewflow-step .step-sec .progressbar {
  border: 2px solid lightgray;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 5px;
}
.view-flow .container1 .viewflow-step .step-sec .progressbar .w3-round {
  height: 7px;
  background: #5ea1d8;
  background: lightgrey;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap img {
  max-width: 100% !important;
  height: 100%;
  object-fit: cover;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap + .item {
  width: calc(100% - 0px) !important;
  margin: 17px 0px !important;
  border: 0px !important;
}
.view-flow .clickarrow {
  width: 100%;
  display: block;
  position: absolute;
  margin-top: 0px;
  width: 100%;
  height: 35px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  position: fixed;
  position: absolute;
  max-width: 1000px;
}
.view-flow .clickarrow button.owl-prev {
  position: absolute;
  background: #fafafa !important;
  background: transparent !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  left: 0px;
}
.view-flow .clickarrow button.owl-prev span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}
.view-flow .clickarrow button.owl-next {
  position: absolute;
  background: #fafafa !important;
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
}
.view-flow .clickarrow button.owl-next span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}
.view-flow .partOfBundle {
  padding: 0px 20px 20px;
  background: #fff;
  background: transparent;
  margin: 0px 20px 0px 0px;
  border-radius: 10px;
  overflow-x: scroll;
}
.view-flow .partOfBundle h2 {
  margin-top: 0px;
  margin-bottom: 0px !important;
}
.view-flow .partOfBundle .row {
  flex-wrap: nowrap !important;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 10px !important;
}
.view-flow .partOfBundle .item {
  background: #fff;
  margin-left: 0px;
  width: 170px !important;
  padding: 10px;
  margin-right: 10px;
  position: relative;
}
.view-flow .partOfBundle .item > div:first-child img {
  height: 150px !important;
}
.view-flow .partOfBundle .item > div:last-child p {
  height: 25px !important;
}
.view-flow .qr-ico {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  position: absolute;
  right: 20px;
}
.view-flow .qr-ico i {
  flex: 1;
  font-size: 25px;
  color: grey;
}
.view-flow .qr-ico p {
  font-weight: 600;
}
.view-flow .material-icons,
.view-flow .align-items-center {
  color: #212427 !important;
  font-weight: normal !important;
  cursor: pointer;
  display: flex;
}
.view-flow img {
  width: 100%;
}
.view-flow p {
  font-family: "Raleway";
  font-size: 15px;
  line-height: 20px;
}
.view-flow button {
  padding: 3px 10px;
  border: 0px;
  font-size: 15px;
  border-radius: 5px;
}
.view-flow button.active {
  background: #5ea1d8;
  color: white;
}
.view-flow h2 {
  font-family: "Raleway";
  margin-bottom: 20px;
}
.view-flow h2 a {
  color: #212427 !important;
}
.view-flow h3 {
  font-family: "Raleway";
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
.view-flow ul {
  display: flex;
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.view-flow li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.view-flow .like .qrcode {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.view-flow .description-wrapper .des-item .des {
  /*max-height:200px;*/
}
.view-flow .description-wrapper .des-item .des p {
  max-height: 100px;
  overflow-y: auto;
}
.view-flow .des-item .des > div span {
  flex: 1;
  font-family: "RALEWAY";
}
.view-flow .des-item .des > div span.material-icons.ng-star-inserted {
  max-width: 30px;
}
.view-flow .des-item .des > div span:first-child {
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.view-flow .des-item .des > div span:last-child {
  text-align: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.view-flow .des-item .des > div span i {
  margin-right: 5px;
}
.view-flow .des-item .item {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 40px 20px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin-top: 20px;
}
.view-flow .des-item .item .list {
  display: flex;
  /* padding: 20px 0px; */
  max-height: 150px;
  overflow-y: auto;
  align-items: flex-start;
}
.view-flow .des-item .item .list ul {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px 0px 20px;
  padding: 5px;
}
.view-flow .des-item .item .list ul li {
  font-family: "Raleway";
  font-size: 14px;
  line-height: 28px;
  word-break: break-all;
  position: relative;
  padding-left: 17px;
}
.view-flow .des-item .item .list ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 10px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.view-flow .des-item .item .list ul li:first-child {
  padding-left: 0px;
}
.view-flow .des-item .item .list ul li:first-child:before {
  display: none;
}
.view-flow .des-item .item .list ul li:first-child {
  font-weight: 600;
}
.view-flow video {
  max-width: 100% !important;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow:empty {
  display: none !important;
}

.step-sec .img-wrap:after {
  content: "›";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  right: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.step-sec .img-wrap:before {
  content: "‹";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.des-item .des p::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .des p::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.des-item .item .list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .item .list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .item .list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.step-sec {
  text-align: center;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.progressbar ul {
  display: flex;
  flex-basis: 100%;
}

.progressbar ul li {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressbar ul li a {
  width: 20px;
  height: 20px;
  background: #5ea1d8;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  font-family: "RALEWAY";
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar ul li a:before {
  counter-increment: my-sec-counter;
  content: "" counter(my-sec-counter) "";
}

img {
  max-width: 100%;
}

@media only screen and (max-width: 1025px) and (min-width: 320px) {
  .view-flow h2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 320px) {
  .view-flow .container1 {
    display: flex;
    flex-direction: column;
    padding: 0px 15px 20px;
  }
  .view-flow .container1 .user-sec {
    flex-direction: column;
  }
  .view-flow .container1 .user-sec .user-details {
    flex-direction: column;
    order: 2;
  }
  .view-flow .container1 .user-sec .user-details .user-ico {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like {
    display: flex;
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
    font-size: 20px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 0px !important;
  }
  .view-flow .container1 .user-sec .qr-code {
    padding: 10px 0px;
  }
  .view-flow .description-wrapper {
    flex-direction: column;
    margin: 0px;
    margin-bottom: 20px;
  }
  .view-flow .description-wrapper .des-item {
    margin-right: 0px;
    margin-bottom: 20px;
    flex-basis: 100%;
    max-width: unset;
    border-right: 0px;
    padding-right: 0px;
  }
  .view-flow .description-wrapper .des-item .des > div span:first-child {
    justify-content: flex-start;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap {
    display: flex;
    flex-direction: column;
    flex: none;
    color: #212427;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap > * {
    margin-right: 10px;
  }
  .view-flow .viewflow-step {
    width: 100%;
    margin: 0px auto 20px;
  }
  .view-flow .viewflow-step .des-item {
    flex-basis: 100%;
    max-width: unset;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 20px;
  }
  .view-flow .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .viewflow-step .step-sec {
    padding: 0px;
    margin-left: 0px;
    width: 100%;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .view-flow .ico-details .profilepic {
    flex-wrap: nowrap;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
    width: 100% !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner + .qrcode {
    width: 100%;
    justify-content: flex-end;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic + .like-list {
    flex-direction: column;
  }
  .view-flow .container1 .viewflow-step .step-sec {
    width: 100%;
    margin: 0px;
  }
  .supportingdoc {
    position: relative !important;
    padding: 10px 10px 10px 0px !important;
  }
}
/*table struture starts here*/
.table-wrap {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 7px;
}
.table-wrap::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.table-wrap::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

table {
  padding-right: 20px;
  width: 100%;
}
table tr {
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
}
table tr th {
  font-family: "Raleway";
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 48%;
  word-break: break-all;
  margin-bottom: 15px;
  line-height: 25px;
}
table tr td {
  width: 100%;
  word-break: break-all;
  margin-bottom: 15px;
  font-family: "Raleway";
  font-weight: 400;
  line-height: 25px;
  font-size: 13px;
  position: relative;
  padding-left: 15px;
  display: flex;
}
table tr td > span {
  width: 48%;
  overflow-wrap: break-word;
}
table tr td > span:first-child {
  margin-right: 4%;
}
table tr td:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 8px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.like-list .fashion-btn {
  display: block;
}

.qr-code .lock,
.qr-code .fashion-btn {
  display: none;
}

@media only screen and (max-width: 992px) and (min-width: 461px) {
  .view-flow .container1 .user-sec .user-details {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding-left: 15px;
    max-width: 100%;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: -15px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 15px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px !important;
  }
  .view-flow .container1 .description-wrapper {
    width: auto;
    margin: 10px 20px;
  }
  .view-flow .container1 .description-wrapper .step-sec .img-wrap {
    max-height: unset;
  }
  .view-flow .container1 .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-next {
    right: -8px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-prev {
    left: -8px;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -45px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -45px;
  }
}
@media only screen and (max-width: 460px) and (min-width: 320px) {
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 11px !important;
  }
  .ico-details .profilepic > div:last-child span {
    font-size: 11px;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: 0px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: 0px;
  }
  .view-flow .viewflow-step {
    width: auto;
    margin: 10px 0px;
  }
  .qr-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .qr-code .priceIcon-wp {
    position: relative !important;
    top: -2px;
  }
  .qr-code .lock > span {
    display: flex;
    align-items: center;
  }
  .qr-code .lock,
  .qr-code .fashion-btn {
    display: block;
  }
  .profilepic .lock {
    display: none !important;
  }
  .like-list .fashion-btn {
    display: none !important;
  }
  .view-flow h2 span {
    font-size: 20px !important;
    word-break: break-word;
  }
  .view-flow .container1 .user-sec {
    padding: 10px;
    margin: 0px;
  }
  .ico-details .profilepic .profinner > div {
    margin-right: 5px;
  }
  .ico-details .profilepic > div {
    margin-right: 0px;
  }
  .viewflow-step .des-item .des p {
    max-height: 133px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
    font-size: 9px;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
button.common {
  padding: 3px 6px !important;
  background: #5ea1d8 !important;
  border: 0px !important;
  color: #fff !important;
  font-size: 13px !important;
  border-radius: 5px !important;
}

@media (max-width: 500px) {
  .ico-details .profilepic .qrcode {
    justify-content: center;
  }
}
.example-list {
  max-width: 100%;
  height: auto;
  display: flex;
  background: white;
  flex-direction: column;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
  flex: 1;
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-list .example-box .item-name {
  text-align: left;
  width: 70%;
}
.example-list .example-box .item-value {
  text-align: left;
  width: 30%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list .example-box img {
  border-bottom: 0px;
  width: 40px !important;
  max-width: 40px;
  height: 40px !important;
  object-fit: cover;
}
.example-list .example-box > * {
  flex: 1;
  color: #212427 !important;
  font-weight: normal !important;
}
.example-list .example-box a {
  color: #007bff !important;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.img-div-left {
  position: fixed;
  z-index: 9999999 !important;
  height: 100px;
  width: 100px;
  overflow: visible;
  margin: auto;
  top: 5% !important;
  left: 0;
  bottom: 0;
  right: 0;
}
.img-div-left img {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0% !important;
}

/*new design starts here*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

.mat-accent {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.example-list .example-box .item-name {
  padding-left: 10px !important;
  border-right: 1px solid #ddd;
}
.example-list .example-box .item-value {
  padding-left: 10px !important;
}

.textcolor {
  color: #5ea1d8;
}

.item .img {
  height: 150px !important;
  background-color: lightgray;
}

p {
  margin: 0px;
}

.zoom {
  cursor: pointer;
  width: 100%;
  height: 70%;
  transition: transform 0.1s;
  /* Animation */
}

.zoom:hover {
  border-radius: 5px;
  transform: scale(1.1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
}

button span {
  font-size: 55px;
}

.owl-nav {
  display: none;
}

.with-icon {
  display: flex;
  align-items: center;
}

.mat-badge-content {
  background: #5ea1d8;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
  z-index: 100;
}

.user-pro .row {
  justify-content: left;
}
.user-pro .ng-star-inserted {
  width: 15.6%;
  margin-right: 1%;
}
.user-pro .item {
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.user-pro .item > div {
  margin: 5px;
}
.user-pro .item p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.user-pro .item p:last-of-type {
  height: auto !important;
}
.user-pro .item .with-icon {
  width: 100%;
  font-family: "Raleway";
  display: flex;
  align-items: center;
}
.user-pro .item .with-icon > div {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-right: 5px;
}
.user-pro .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
}
.user-pro .item .zoom {
  margin: 5px;
  width: calc(100% - 10px);
  background-color: transparent;
}
.user-pro .item img {
  height: 150px;
  object-fit: cover;
  width: 100%;
  border: 1px solid #dddddd;
}

@media only screen and (max-width: 1024px) and (min-width: 993px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 18% !important;
    width: 18% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    font-family: "Raleway";
    display: flex;
    align-items: center;
    max-width: 100% !important;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 23% !important;
    width: 23% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media screen and (max-width: 460px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 7px;
  }
}
.scroll .item .uni-wrapper .bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
}
.scroll .item .uni-wrapper .bundleIcon img {
  width: 100% !important;
  height: 20px !important;
  object-fit: contain;
  border: none;
}

.uni-wrapper P {
  flex: 1;
}

/*new design starts here new bundle*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.bundleIcons {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  padding-left: 5px;
}
.bundleIcons img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.partOfBundle .item .uni-wrapper {
  display: flex;
}
.partOfBundle .item .uni-wrapper p {
  justify-content: flex-start !important;
}

.uni-wrapper P {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media (max-width: 1024px) {
  .view-flow .container1 .user-sec {
    margin: 0px !important;
  }
  .view-flow .viewflow-step {
    width: 100% !important;
    margin: 10px 0px !important;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
@media (max-width: 992px) {
  .view-flow .viewflow-step .des-item {
    padding: 0px;
    border: 0px;
    flex-basis: 100% !important;
    max-width: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .view-flow .viewflow-step .des-item .des {
    padding: 0px;
    padding: 0px 0px 20px !important;
  }
  .view-flow .viewflow-step .des-item .des p {
    margin: 0px;
  }
  .view-flow .qr-ico {
    position: relative;
    right: 0px;
  }
}
.font16 {
  font-size: 14px !important;
  font-family: "Raleway";
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: bold;
}

.priceIcon-p .font16 {
  font-size: 10px !important;
  color: #fff !important;
}

.timer-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.timer-wrap br {
  display: none;
}
.timer-wrap h6 {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}
.timer-wrap .icon-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.timer-wrap .icon-wrap .textbodycolor {
  justify-content: flex-start !important;
  padding-left: 10px;
}

.newdesignadd {
  display: block;
  width: 100%;
  color: #212427;
  border: 1px solid lightgray;
  border: 0px !important;
  padding-left: 0px;
}
.newdesignadd .item-name {
  justify-content: flex-start !important;
}
.newdesignadd .item-name a {
  color: #5ea1d8;
}

.timer-wrap + h6 {
  margin-bottom: 15px;
}

.not-draggable {
  -webkit-user-drag: none;
  /* Safari/Chrome */
  /* Firefox */
  /* IE10+ */
  -webkit-user-select: none;
          user-select: none;
  /* Standard syntax */
  cursor: default;
  /* Optional: Change the cursor style */
  transform: translate(0, 0) !important;
}

.divscroll {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divscroll div {
  width: 100% !important;
}

.view-flow .container1 .viewflow-step .step-sec .img-wrap {
  flex: none !important;
}

@media (max-width: 767px) {
  .partOfBundle {
    padding: 0px 0px 20px 0px !important;
    margin-right: 0px !important;
  }
  .partOfBundle h2 {
    margin-top: 0px !important;
  }
  .view-flow .container1 .viewflow-step {
    margin-bottom: 10px !important;
  }
  .view-flow .partOfBundle h2 {
    margin-top: 15px !important;
  }
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) {
  position: relative;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) span {
  position: relative;
}

/*chatbot design*/
.chatbot-wrapper {
  position: fixed;
  bottom: 0px;
  right: 20px;
  padding: 20px;
  display: flex;
  padding: 20px 0px 0px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px 10px 0px 0px;
  max-width: 400px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  flex-wrap: wrap;
  min-height: 400px;
  max-height: calc(100% - 120px);
  overflow-y: hidden;
  flex-direction: row;
}
.chatbot-wrapper:before {
  content: "";
  width: 100%;
  height: 31%;
  height: 124px;
  background: rgb(94, 161, 216) !important;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
}
.chatbot-wrapper .chatbot-msg {
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close h5 {
  color: #fff;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text {
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text h2 {
  color: #fff !important;
  font-size: 20px !important;
  margin-bottom: 10px !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text p {
  color: #fff !important;
  font-weight: 400 !important;
  margin: 0px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 100%;
  overflow: hidden;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .image {
  margin-bottom: 20px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category {
  display: flex;
  flex-wrap: wrap;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul {
  margin: 0px;
  margin-top: 10px !important;
  padding: 0px !important;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  background: transparent !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li {
  padding: 10px;
  background: rgb(94, 161, 216) !important;
  border-radius: 10px;
  border: 1px solid #ddd;
  margin: 0px;
  margin-right: 5px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li a {
  color: #fff !important;
}
.chatbot-wrapper .chatbot-btn {
  width: 100%;
  cursor: pointer;
  margin-bottom: 0px;
  padding: 0px 0px 0px 20px;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  flex: 1;
  margin-bottom: 10px;
}
.chatbot-wrapper .chatbot-btn img {
  width: 80px;
}
.chatbot-wrapper .chatbot-converasation {
  margin-bottom: 20px;
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-converasation .chat-user,
.chatbot-wrapper .chatbot-converasation .new-user {
  max-width: 75%;
  padding: 10px 10px;
  background: #f6f6f6;
  display: inline-flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  align-items: flex-start;
  position: relative;
  margin-left: 35px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}
.chatbot-wrapper .chatbot-converasation .chat-user p,
.chatbot-wrapper .chatbot-converasation .new-user p {
  margin: 0px !important;
}
.chatbot-wrapper .chatbot-converasation .chat-user:before,
.chatbot-wrapper .chatbot-converasation .new-user:before {
  content: "";
  background: url('chat-bot.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}
.chatbot-wrapper .chatbot-converasation .new-user {
  display: flex;
  justify-content: flex-end;
  float: right;
}
.chatbot-wrapper .chatbot-converasation .new-user:before {
  display: none;
}
.chatbot-wrapper .chatbot-stickyfooter {
  width: 100%;
  position: sticky;
  bottom: 0px;
  padding: 5px 20px;
  background: #5ea1d8;
  display: flex;
  height: 50px;
}
.chatbot-wrapper .chatbot-stickyfooter .input {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 10px;
}
.chatbot-wrapper .chatbot-stickyfooter .input input {
  width: 100%;
  border: 1px solid #000;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 0px;
  height: 40px;
  border: 0px;
  padding-left: 30px;
  outline: none !important;
}
.chatbot-wrapper .chatbot-stickyfooter .input i {
  position: absolute;
  z-index: 2;
}
.chatbot-wrapper .chatbot-stickyfooter .mic {
  width: 40px;
  height: 100%;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-div {
  min-height: 224px !important;
  overflow-y: scroll;
  padding-bottom: 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.sticky-chat {
  position: sticky;
  top: -20px;
  z-index: 1000;
  padding: 10px;
  width: 100%;
  height: 104px;
}

.sticky-default {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
}
.sticky-default img {
  width: 80px;
}

.chatbot-msg {
  height: 104px;
}

.scroll-div {
  max-height: 425px;
}
.scroll-div .chatbot-msg {
  height: auto !important;
}
.scroll-div .faq-list {
  padding: 0px 20px;
}

@media (max-width: 767px) {
  .chatbot-wrapper {
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 20px;
    display: flex;
    padding: 20px 0px 0px;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
    margin: 0px 20px 0px 20px;
    border-radius: 10px 10px 0px 0px;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    z-index: 1000;
    flex-wrap: wrap;
    max-height: 90vh;
    /* Limits max height but allows it to expand */
    overflow-y: auto;
    /* Enables scrolling when needed */
    flex-direction: row;
    left: 0px;
    margin: 0px auto;
  }
}
.flow-container {
  display: flex;
  gap: 20px;
}

/* Left: Expansion Panel */
.steps-panel {
  width: 100%;
}

mat-expansion-panel {
  background: #f8f9fa;
  margin-bottom: 5px;
}

mat-expansion-panel-header {
  font-weight: bold;
  color: white;
  cursor: pointer;
}

mat-expansion-panel-header:hover {
  background-color: rgba(200, 193, 193, 0.5);
}

/* Right: Step Content */
.step-content {
  width: 100%;
  padding-left: 10px;
}

.step-content h3 {
  margin-bottom: 10px;
}

.step-content video,
.step-content img {
  display: block;
  margin-top: 10px;
  border-radius: 5px;
}

.viewflow-step .flow-container {
  width: 100%;
}
.viewflow-step .description {
  width: 100%;
}

.step-scroll {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  display: flex;
}

.steps-list {
  display: flex;
  gap: 5px;
  margin-bottom: 10px;
}
.steps-list button {
  white-space: nowrap;
  margin-bottom: 10px !important;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 5px;
  /* Space between icon and text */
  margin-top: 10px;
  margin-left: 7px;
  margin-right: 346px;
}

.keyword-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.keyword-container.less span {
  flex: unset !important;
}
.keyword-container.less span:nth-child(n+5) {
  display: none;
}
.keyword-container.less span:nth-last-child(-n+2) {
  display: inline;
}
.keyword-container.less .less-btn {
  display: none !important;
  width: 100% !important;
  flex: unset !important;
}
.keyword-container.more span {
  flex: unset !important;
}
.keyword-container.more span:nth-child(n+5) {
  display: inline;
}
.keyword-container.more span:nth-last-child(-n+2) {
  display: inline;
}
.keyword-container.more .more-btn {
  display: none !important;
  width: 100% !important;
  flex: unset !important;
}

.more-btn,
.less-btn {
  width: 100% !important;
  flex: unset !important;
  justify-content: flex-start !important;
}

span.showmore {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hashtag {
  font-family: "Montserrat", sans-serif !important;
  font-size: 12px;
  font-weight: bold;
  color: #5ea1d8;
  padding: 2px 6px;
  /* Reduced padding */
  border-radius: 12px;
  /* Optional: Makes it look like a pill */
  background: rgba(94, 161, 216, 0.1);
  /* Light background for visibility */
  display: inline-block;
  margin: 2px;
  /* Minimal spacing between hashtags */
}

.more-btn,
.less-btn {
  font-size: 12px;
  color: #888;
  cursor: pointer;
  margin-left: 4px;
  /* Ensures it stays close to last hashtag */
}

.carousel {
  width: 300px;
  height: 200px;
  background-color: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  -webkit-user-select: none;
          user-select: none;
}

.slide {
  padding: 20px;
  font-weight: bold;
}

.step-header {
  display: flex;
  align-items: center;
  /* Vertically center all elements */
  gap: 8px;
  /* Space between elements */
  width: 100%;
}
.step-header .s-num {
  margin-bottom: 0px !important;
}
.step-header .share-icon {
  align-items: center !important;
}

.s-num {
  font-size: 16px;
  /* Adjust size as needed */
  font-weight: bold;
  /* Optional: make step number stand out */
  padding: 4px 8px;
  /* Optional: padding for better appearance */
}

.share-icon {
  font-size: 16px;
  /* Match font size for consistency */
  cursor: pointer;
  /* Indicate clickability */
  margin-left: auto;
  /* Push icon to the right */
}

mat-panel-title {
  display: flex;
  align-items: center;
  /* Vertically center elements */
  justify-content: space-between;
  /* Push share icon to the right */
  width: 100%;
  /* Ensure full width */
  margin-top: 10px;
}

.step-info {
  margin-top: 5px !important;
  display: flex;
  align-items: center;
  align-items: flex-start;
  /* Align content to the left */
  gap: 8px;
  /* Space between step number and title */
}

.step-number {
  font-size: 16px;
  /* Adjust as needed */
  font-weight: bold;
  /* Optional: emphasize step number */
}

.step-title {
  font-size: 16px;
  /* Match your h3 or desired size */
  flex-grow: 1;
  /* Allow title to take available space */
  white-space: normal;
  /* Allow title to wrap to the next line */
  display: block;
  /* Ensure it takes the full width and moves to the next line */
}

.share-icon {
  font-size: 16px;
  /* Match text size */
  cursor: pointer;
  /* Indicate clickability */
  vertical-align: middle;
  /* Align with text */
}

mat-expansion-panel-header {
  min-height: 48px;
  /* Default height, but allows growing */
  height: auto;
  /* Allow dynamic height based on content */
  align-items: flex-start;
  /* Align content to the top for better wrapping */
  padding: 0 16px;
  /* Adjust padding if needed (default Material padding) */
}

/* Override mat-expansion-panel-header for both collapsed and expanded states */
:host ::ng-deep mat-expansion-panel-header {
  min-height: 48px;
  /* Default height, but allows growing */
  height: auto;
  /* Dynamic height based on content */
  align-items: flex-start;
  /* Align content to the top */
  padding: 0 16px;
  /* Default Material padding, adjust if needed */
}

/* Ensure expanded state also respects dynamic height */
:host ::ng-deep .mat-expansion-panel-header.mat-expanded {
  min-height: 48px;
  /* Allow growing in expanded state */
  height: auto;
  /* Dynamic height */
  align-items: flex-start;
  /* Align content to the top */
}

.close-ico {
  position: absolute;
  top: 15px;
  right: 25px;
  color: white;
  opacity: 1 !important;
  z-index: 10;
  position: fixed;
  top: unset;
  right: unset;
  max-width: 360px;
  width: 100%;
  margin: 0px auto;
  left: 0px;
  right: 0px;
  text-align: right;
}

.close-ico .fal {
  font-size: 25px;
  padding-right: 15px;
  padding-top: 5px;
}

.btn-wrap {
  height: 35px;
  font-size: 14px;
  cursor: pointer;
  color: white;
  background-color: #5ea1d8;
  border-radius: 5px;
}

/* (Removed dialog-specific overrides for flow-layout, flow-info-panel, etc.
   to let viewflow.component.scss define the exact mobile layout styles.) */`, "",{"version":3,"sources":["webpack://./src/app/pages/view-reported-flow/view-reported-flow.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EAEE,WAAA;EACA,gBAAA,EAAA,gCAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EAEA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EACA,mBAAA;AADJ;AAGI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADN;AAII;EACE,cAAA;AAFN;AAME;EACE,OAAA;EACA,gBAAA;EACA,UAAA;AAJJ;AAOI;EACE,2BAAA;EACA,kCAAA;AALN;AASI;EACE;;;;;GAAA;EAMA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAPN;AASM;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;AAPR;AASQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;AAPV;AASU;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAPZ;AAUU;EACE,WAAA;EACA,eAAA;AARZ;AAcM;;;;EAIE,0CAAA;EACA,0BAAA;EACA,yFAAA;EAEA,yBAAA;AAbR;AAgBM;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAdR;AAgBQ;EACE,YAAA;EACA,UAAA;AAdV;AAiBQ;EACE,YAAA;EACA,UAAA;AAfV;AAkBQ;EACE,YAAA;EACA,WAAA;AAhBV;AAmBQ;EACE,UAAA;AAjBV;AAoBQ;EACE,YAAA;EACA,WAAA;EACA,aAAA;AAlBV;AAoBU;EACE,UAAA;AAlBZ;AAsBQ;EACE,YAAA;EACA,WAAA;EACA,SAAA;AApBV;AAuBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AArBV;AAwBQ;EACE,YAAA;EACA,UAAA;AAtBV;AA0BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAxBR;AA0BQ;EACE,WAAA;EACA,YAAA;AAxBV;AA4BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA1BV;AA8BM;EACE,WAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA5BR;AA8BQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0BAAA;EACA,yFAAA;EAEA,yBAAA;AA7BV;AAgCQ;EACE,sBAAA;AA9BV;AAkCM;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,WAAA;EACA,sBAAA;AAhCR;AAmCM;EACE,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;AAjCR;AAmCQ;EACE,YAAA;EACA,UAAA;AAjCV;AAqCM;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAnCR;AAqCQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAnCV;AAwCQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAtCV;AAwCU;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAtCZ;AA2CU;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAzCZ;AA2CY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAzCd;AAgDQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA9CV;AAgDU;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA9CZ;AAoDQ;EACE,mBAAA;AAlDV;AAqDQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnDV;AAyDI;EACE;IACE,4BAAA;EAvDN;EAyDI;IACE,2BAAA;EAvDN;AACF;AA0DI;EACE;IACE,UAAA;EAxDN;EA0DI;IACE,YAAA;EAxDN;EA0DI;IACE,UAAA;EAxDN;AACF;AA4DE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AA1DJ;;AA8DA;4EAAA;AAGA;EACI,uBAAA;EACA,gBAAA;EACA,gBAAA;AA5DJ;;AA+DA;EACI,gBAAA;EACA,sBAAA;EAGA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;AA9DJ;;AAiEA;EACI,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA9DJ;;AAiEA;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AA9DJ;;AAiEA;EACI,YAAA;EACA,WAAA;AA9DJ;;AAiEA;EACI,mBAAA;EACA,6BAAA;AA9DJ;;AAkEA;EACI,kCAAA;EACA,2BAAA;EACA,yBAAA;AA/DJ;AAiEI;EACI,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,kCAAA;AA/DR;AAkEQ;EACI,sBAAA;EACA,qBAAA;EACA,oBAAA;AAhEZ;AAkEY;EACI,wBAAA;EACA,qCAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,wBAAA;EACA,kCAAA;AAhEhB;AAmEgB;EACI,wBAAA;AAjEpB;AAqEY;EACI,sBAAA;EACA,uBAAA;EACA,0BAAA;EAwBA,gGAAA;AA1FhB;AAqEgB;EACI,sCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kDAAA;EACA,2CAAA;EACA,gCAAA;EACA,6BAAA;AAnEpB;AAsEgB;EACI,sCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;AApEpB;AAwEgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAQA,oDAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;AA7EpB;AAgEoB;EATJ;IAUQ,mBAAA;IACA,kBAAA;IACA,gBAAA;EA7DtB;AACF;AAwEoB;EACI,WAAA;AAtExB;AAyEoB;EACI,8BAAA;EACA,kBAAA;AAvExB;AA0EoB;EACI,8BAAA;AAxExB;AA2EoB;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAzExB;AA2EwB;EACI,mBAAA;EACA,qBAAA;AAzE5B;AA4EwB;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;AA1E5B;AA4E4B;;;EAGI,cAAA;AA1EhC;AA8EwB;EACI,eAAA;EACA,cAAA;EACA,cAAA;AA5E5B;AA+EwB;EACI,kCAAA;EACA,cAAA;EACA,eAAA;AA7E5B;AAgFwB;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9E5B;AAmFgB;EACI,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2CAAA;AAjFpB;AAmFoB;EACI,wBAAA;EACA,kCAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;AAjFxB;AAmFwB;EACI,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;AAjF5B;AAqFoB;EACI,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;AAnFxB;AAsFoB;EACI,2BAAA;EACA,6BAAA;EACA,oCAAA;EACA,2BAAA;AApFxB;AAsFwB;EACI,sBAAA;AApF5B;AAuFwB;EACI,yCAAA;EACA,6BAAA;AArF5B;AAwFwB;EACI,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AAtF5B;AAwF4B;EACI,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0BAAA;EACA,sCAAA;AAtFhC;AAwFgC;EACI,8BAAA;AAtFpC;AAyFgC;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;AAvFpC;AA0FgC;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;AAxFpC;AA2FgC;EACI,yBAAA;AAzFpC;AA2FoC;EACI,yBAAA;AAzFxC;AAiGgB;EACI,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,2CAAA;AA/FpB;AAiGoB;EACI,wBAAA;EACA,8BAAA;EACA,oBAAA;AA/FxB;AAiGwB;EALJ;IAMQ,oBAAA;IACA,kCAAA;EA9F1B;AACF;AAgGwB;EACI,yBAAA;AA9F5B;AAgG4B;EACI,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;AA9FhC;AAgGgC;EAPJ;IAQQ,sBAAA;IACA,uBAAA;EA7FlC;AACF;AAgG4B;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;AA9FhC;AAgGgC;EAPJ;IAQQ,0BAAA;IACA,sBAAA;IACA,uBAAA;EA7FlC;AACF;AAiGwB;EACI,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,wBAAA;EACA,iCAAA;EACA,kCAAA;AA/F5B;AAiG4B;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,kCAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;EACA,kCAAA;EACA,6BAAA;EACA,iCAAA;AA/FhC;AAiGgC;EAhBJ;IAiBQ,0BAAA;IACA,6BAAA;EA9FlC;AACF;AAgGgC;EACI,yBAAA;AA9FpC;AAkG4B;EACI,wBAAA;EACA,8BAAA;EACA,sCAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EACA,iCAAA;AAhGhC;AAkGgC;EACI,+BAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;AAhGpC;AAuGgB;EACI,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,8BAAA;AArGpB;AAuGoB;EACI,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,+BAAA;EACA,6BAAA;AArGxB;AAuGwB;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,kBAAA;EACA,sCAAA;EACA,kCAAA;EACA,6BAAA;EACA,8BAAA;AArG5B;AAyGoB;EACI,2BAAA;AAvGxB;AA0GwB;EACI,2BAAA;EACA,2BAAA;EACA,2CAAA;AAxG5B;AA2GwB;EACI,2BAAA;EACA,4BAAA;AAzG5B;AA6GoB;EACI,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qBAAA;AA3GxB;AA6GwB;EACI,yBAAA;AA3G5B;AAiHgB;EACI,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,8BAAA;AA/GpB;AAmHgB;EACI,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;AAjHpB;AAmHoB;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;AAjHxB;AAoHoB;EACI,wBAAA;EACA,oBAAA;EACA,8BAAA;AAlHxB;AAoHwB;EACI,yBAAA;AAlH5B;AAoH4B;EACI,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;AAlHhC;AAqH4B;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AAnHhC;AAuHwB;EACI,kBAAA;EACA,6BAAA;AArH5B;AAuH4B;EACI,wBAAA;EACA,8BAAA;EACA,mBAAA;AArHhC;AAwH4B;EACI,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2CAAA;EACA,0BAAA;EACA,yBAAA;EACA,kCAAA;AAtHhC;AAwHgC;EACI,wBAAA;EACA,uCAAA;AAtHpC;AAyHgC;EACI,yBAAA;AAvHpC;AA2H4B;EACI,yBAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,+BAAA;AAzHhC;AA2HgC;EACI,8BAAA;EACA,yBAAA;AAzHpC;AA4HgC;EACI,sBAAA;EACA,8BAAA;AA1HpC;AA6HgC;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;AA3HpC;AAiIoB;EACI,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;AA/HxB;AAiIwB;EACI,oBAAA;EACA,0BAAA;EACA,yBAAA;AA/H5B;AAiI4B;EACI,yBAAA;EACA,0BAAA;EACA,gCAAA;AA/HhC;AAiIgC;EACI,qCAAA;AA/HpC;AAqIoB;EACI,2BAAA;AAnIxB;AAqIwB;EACI,wBAAA;EACA,iCAAA;EACA,0BAAA;EACA,2CAAA;AAnI5B;AAqI4B;EACI,8BAAA;AAnIhC;AAsI4B;EACI,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,6BAAA;AApIhC;AAsIgC;EACI,wBAAA;EACA,8BAAA;EACA,mBAAA;AApIpC;AAsIoC;EACI,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;AApIxC;AAuIoC;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AArIxC;AAwIoC;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6CAAA;AAtIxC;AA0IgC;EACI,0BAAA;EACA,yBAAA;EACA,6CAAA;AAxIpC;AA4I4B;EACI,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,6BAAA;EACA,6CAAA;AA1IhC;AA6I4B;EACI,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,4BAAA;EACA,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,gCAAA;AA3IhC;AA6IgC;EACI,sBAAA;AA3IpC;AA8IgC;EACI,yCAAA;EACA,6BAAA;AA5IpC;AA+IgC;EACI,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,sCAAA;EACA,yBAAA;AA7IpC;AA+IoC;EACI,8BAAA;AA7IxC;AAgJoC;EACI,yBAAA;AA9IxC;AAiJoC;EACI,0BAAA;EACA,sBAAA;EACA,uBAAA;AA/IxC;AAkJoC;EACI,0BAAA;EACA,2BAAA;AAhJxC;AAuJoB;EACI,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AArJxB;AAuJwB;EACI,oBAAA;AArJ5B;AA0JgB;EACI,sBAAA;EACA,qBAAA;AAxJpB;AA8JQ;EACI,2BAAA;EACA,4BAAA;EACA,wCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;AA5JZ;AA8JY;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;EACA,8BAAA;AA5JhB;AA+JY;EACI,wBAAA;EACA,iCAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;EACA,qBAAA;AA7JhB;AAgKY;EACI,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;EACA,8BAAA;EACA,qBAAA;AA9JhB;AAgKgB;EACI,8BAAA;AA9JpB;AAkKY;EACI,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;AAhKhB;AAkKgB;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;AAhKpB;AAoKY;EACI,kBAAA;EACA,uBAAA;AAlKhB;AAoKgB;EACI,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,4BAAA;EACA,8BAAA;EACA,iCAAA;EACA,2BAAA;AAlKpB;AAqKgB;EACI,wBAAA;EACA,iCAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;EACA,0BAAA;AAnKpB;AAqKoB;EACI,yBAAA;AAnKxB;AAsKoB;EACI,yBAAA;AApKxB;AAwKgB;EACI,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;AAtKpB;;AA8KA;EACI,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;AA3KJ;;AA8KA;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EAymBA,kCAAA;AAnxBJ;AA4KI;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;AA1KR;AA4KQ;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AA1KZ;AA4KY;EACI,OAAA;EACA,aAAA;AA1KhB;AA4KgB;EACI,OAAA;EACA,wBAAA;AA1KpB;AA4KoB;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA1KxB;AA8KgB;EACI,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AA5KpB;AA8KoB;EACI,8BAAA;EACA,0BAAA;EACA,oCAAA;AA5KxB;AA+KoB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA7KxB;AA+KwB;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA7K5B;AA+K4B;EACI,WAAA;EACA,kBAAA;EACA,cAAA;AA7KhC;AAgLoC;EACI,qCAAA;EACA,2BAAA;AA9KxC;AAgLwC;EACI,qCAAA;EACA,eAAA;AA9K5C;AAqLwB;EACI,kBAAA;AAnL5B;AAsLwB;EACI,OAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AApL5B;AAsL4B;EACI,2BAAA;EACA,cAAA;AApLhC;AAwLwB;EACI,sBAAA;AAtL5B;AA0L4B;EACI,iBAAA;AAxLhC;AA4LwB;EACI,kBAAA;EACA,eAAA;AA1L5B;AA8LoB;EACI,eAAA;EACA,kBAAA;EACA,aAAA;AA5LxB;AA8LwB;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EAEA,kBAAA;AA7L5B;AA+L4B;EACI,YAAA;EACA,2BAAA;AA7LhC;AA+LgC;EACI,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AA7LpC;AAgMgC;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AA9LpC;AA0MwB;EACI,OAAA;EACA,iBAAA;AAxM5B;AA+MQ;EACI,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AA7MZ;AAgNY;EACI,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;AA9MhB;AAgNgB;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,2BAAA;AA9MpB;AAgNoB;EACI,UAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AA9MxB;AAiNoB;EACI,iBAAA;EACA,mBAAA;AA/MxB;AAkNoB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAjNxB;AAmNwB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EAEA,WAAA;AAlN5B;AAuNgB;EACI,aAAA;EACA,mBAAA;AArNpB;AAuNoB;EACI,OAAA;AArNxB;AAuNwB;EACI,2BAAA;AArN5B;AAwNwB;EACI,sBAAA;EACA,eAAA;AAtN5B;AA0NoB;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AAxNxB;AA0NwB;EACI,aAAA;EACA,mBAAA;AAxN5B;AA8NY;EACI,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,mBAAA;AA5NhB;AA8NgB;EACI,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AA5NpB;AA+NoB;EACI,WAAA;EACA,mBAAA;EACA,qBAAA;AA7NxB;AAiOgB;EACI,OAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;AAhOpB;AAkOoB;EAEI,0BAAA;EACA,YAAA;EACA,iBAAA;EAEA,gBAAA;EACA,sBAAA;AAlOxB;AAqOoB;EACI,kCAAA;EACA,2BAAA;EACA,sBAAA;AAnOxB;AA+QI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA7QR;AA+QQ;EACI,kBAAA;EACA,8BAAA;EACA,kCAAA;EAEA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AA/QZ;AAiRY;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AA/QhB;AAmRQ;EACI,kBAAA;EACA,8BAAA;EACA,+CAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AAlRZ;AAoRY;EACI,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AAlRhB;AAmSI;EACI,sBAAA;EACA,gBAAA;EACA,uBAAA;EAGA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAnSR;AAqSQ;EAEI,eAAA;EACA,6BAAA;AApSZ;AAuSQ;EACI,4BAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;AArSZ;AAwSQ;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAtSZ;AAySgB;EACI,wBAAA;AAvSpB;AA4SgB;EACI,uBAAA;AA1SpB;AAgTI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AA9SR;AAgTQ;EACI,OAAA;EACA,eAAA;EACA,WAAA;AA9SZ;AAiTQ;EACI,gBAAA;AA/SZ;AA2UI;;EAEI,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;AAzUR;AA4UI;EACI,WAAA;AA1UR;AA6UI;EACI,sBAAA;EACA,eAAA;EACA,iBAAA;AA3UR;AA8UI;EACI,iBAAA;EAEA,WAAA;EAEA,eAAA;EACA,kBAAA;AA9UR;AAiVI;EACI,mBAAA;EACA,YAAA;AA/UR;AAmVI;EACI,sBAAA;EACA,mBAAA;AAjVR;AAmVQ;EACI,yBAAA;AAjVZ;AAqVI;EACI,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAnVR;AAsVI;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AApVR;AAuVI;EACI,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AArVR;AA6VQ;EACI,OAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AA3VZ;AA4WY;EACI,oBAAA;AA1WhB;AAoXgB;EACI,iBAAA;EACA,gBAAA;AAlXpB;AA8XI;EACI,OAAA;EACA,sBAAA;AA5XR;AA+XI;EACI,eAAA;AA7XR;AAgYI;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AA9XR;AAiYI;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA/XR;AAkYI;EACI,iBAAA;AAhYR;AAmYI;EACI,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAjYR;AAoYI;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAlYR;AAqYI;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AAnYR;AAsYI;EACI,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,kBAAA;AArYR;AAuYQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;AArYZ;AAwYQ;EACI,iBAAA;AAtYZ;AAwYY;EACI,aAAA;AAtYhB;AA2YI;EACI,gBAAA;AAzYR;AAmZI;EAEI,0BAAA;EAEA,gBAAA;EACA,sBAAA;AAnZR;AAsZI;EACI,wBAAA;AApZR;;AAwZA;EACI,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAvZJ;;AA0ZA;EACI,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAzZJ;;AA4ZA;EACI,UAAA;EACA,aAAA;AAzZJ;;AA4ZA;EACI,oDAAA;AAzZJ;;AA4ZA;EACI,yBAAA;EACA,0BAAA;AAzZJ;;AA4ZA;EACI,UAAA;EACA,aAAA;AAzZJ;;AA4ZA;EACI,oDAAA;AAzZJ;;AA4ZA;EACI,yBAAA;EACA,0BAAA;AAzZJ;;AA4ZA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AAzZJ;;AAmaA;EACI,aAAA;EACA,gBAAA;AAhaJ;;AAmaA;EACI,OAAA;EACA,aAAA;EACA,mBAAA;AAhaJ;;AAmaA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhaJ;;AAmaA;EACI,iCAAA;EACA,sCAAA;AAhaJ;;AAmaA;EACI,eAAA;AAhaJ;;AAmaA;EAIQ;IACI,0BAAA;EAnaV;AACF;AAwaA;EAEQ;IACI,aAAA;IACA,sBAAA;IACA,sBAAA;EAvaV;EAyaU;IACI,sBAAA;EAvad;EA2ac;IACI,sBAAA;IACA,QAAA;EAzalB;EA2akB;IACI,aAAA;IACA,mBAAA;IACA,uBAAA;EAzatB;EA4akB;IACI,YAAA;EA1atB;EA8a8B;IACI,eAAA;EA5alC;EAibsB;IACI,aAAA;IAEA,gBAAA;EAhb1B;EAkb0B;IACI,gBAAA;EAhb9B;EAobkC;IACI,eAAA;EAlbtC;EAwb8B;IACI,4BAAA;EAtblC;EA6bc;IACI,iBAAA;EA3blB;EAgcM;IACI,sBAAA;IACA,WAAA;IACA,mBAAA;EA9bV;EAgcU;IACI,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EA9bd;EAmc0B;IACI,2BAAA;EAjc9B;EAsckB;IACI,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;EApctB;EAscsB;IACI,kBAAA;EApc1B;EAmdM;IACI,WAAA;IACA,qBAAA;EAjdV;EAmdU;IACI,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,oBAAA;EAjdd;EAmdc;IACI,oBAAA;IAEA,kBAAA;EAldlB;EAsdU;IACI,YAAA;IACA,gBAAA;IACA,WAAA;EApdd;EAwdc;IACI,WAAA;IACA,YAAA;EAtdlB;EAueM;IACI,iBAAA;EAreV;EA2eU;IACI,sBAAA;IACA,2BAAA;IACA,0BAAA;EAzed;EA2ec;IACI,WAAA;IACA,yBAAA;EAzelB;EA6eU;IACI,sBAAA;EA3ed;EAgfE;IACI,WAAA;IACA,WAAA;EA9eN;EAifE;IACI,6BAAA;IACA,sCAAA;EA/eN;AACF;AAkfA,6BAAA;AACA;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;AAhfJ;AAkfI;EACI,UAAA;EACA,aAAA;AAhfR;AAmfI;EACI,oDAAA;AAjfR;AAofI;EACI,yBAAA;EACA,0BAAA;AAlfR;;AAsfA;EACI,mBAAA;EACA,WAAA;AAnfJ;AAqfI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AAnfR;AAqfQ;EACI,sBAAA;EACA,2BAAA;EACA,0BAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAnfZ;AAsfQ;EACI,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AApfZ;AAsfY;EACI,UAAA;EACA,yBAAA;AApfhB;AAsfgB;EACI,gBAAA;AApfpB;AAwfY;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;AAtfhB;;AAygBI;EACI,cAAA;AAtgBR;;AA4gBI;;EAEI,aAAA;AAzgBR;;AA6gBA;EAIgB;IACI,mBAAA;EA7gBlB;EAihBkB;IACI,kBAAA;IACA,eAAA;EA/gBtB;EAkhB0B;IACI,kBAAA;EAhhB9B;EAohB8B;IACI,6BAAA;EAlhBlC;EAyhB8B;IACI,0BAAA;EAvhBlC;EA+hBU;IACI,WAAA;IAGA,iBAAA;EA/hBd;EAkiBkB;IACI,iBAAA;EAhiBtB;EAuiBkB;IACI,oBAAA;IAEA,kBAAA;EAtiBtB;EA2iBkB;IACI,WAAA;EAziBtB;EA4iBkB;IACI,UAAA;EA1iBtB;AACF;AAijBA;EAIgB;IACI,WAAA;IACA,YAAA;EAljBlB;EAojBkB;IACI,WAAA;EAljBtB;EAqjBkB;IACI,YAAA;EAnjBtB;AACF;AA0jBA;EACI;IACI,0BAAA;EAxjBN;EA4jBM;IACI,eAAA;EA1jBV;EA+jBM;IACI,WAAA;IACA,YAAA;EA7jBV;EA+jBU;IACI,SAAA;EA7jBd;EAkkBU;IACI,UAAA;EAhkBd;EAukBE;IACI,WAAA;IACA,gBAAA;EArkBN;EAwkBE;IACI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;EAtkBN;EAwkBM;IACI,6BAAA;IACA,SAAA;EAtkBV;EA0kBU;IACI,aAAA;IACA,mBAAA;EAxkBd;EAmlBM;;IAEI,cAAA;EAjlBV;EAslBM;IACI,wBAAA;EAplBV;EAylBM;IACI,wBAAA;EAvlBV;EA2lBE;IACI,0BAAA;IACA,sBAAA;EAzlBN;EA4lBE;IACI,aAAA;IACA,WAAA;EA1lBN;EA6lBE;IACI,iBAAA;EA3lBN;EA8lBE;IACI,iBAAA;EA5lBN;EAmmBE;IACI,iBAAA;EAjmBN;EAomBE;IACI,cAAA;EAlmBN;EAqmBE;IACI,YAAA;IACA,iBAAA;EAnmBN;AACF;AAsmBA;EACI,2BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AArmBJ;;AAwmBA;EACI;IACI,uBAAA;EArmBN;AACF;AAwmBA;EACI,eAAA;EAGA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EAEA,gBAAA;AAzmBJ;AA2mBI;EACI,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;EACA,OAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAzmBR;AA2mBQ;EACI,gBAAA;EACA,UAAA;AAzmBZ;AA4mBQ;EACI,gBAAA;EACA,UAAA;AA1mBZ;AA6mBQ;;;;EAII,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AA3mBZ;AA8mBQ;;EAEI,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AA5mBZ;AA+mBQ;EACI,kBAAA;AA7mBZ;AAgnBQ;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AA9mBZ;AAinBQ;EACI,OAAA;EACA,yBAAA;EACA,8BAAA;AA/mBZ;AAknBQ;EACI,yBAAA;AAhnBZ;AAonBI;EACI,UAAA;EACA,aAAA;AAlnBR;AAqnBI;EACI,oDAAA;AAnnBR;AAsnBI;EACI,yBAAA;EACA,0BAAA;AApnBR;;AAwnBA;EACI,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AArnBJ;AAunBI;EACI,UAAA;EACA,wBAAA;AArnBR;AAunBQ;EACI,UAAA;AArnBZ;AAwnBQ;EACI,UAAA;AAtnBZ;AAynBQ;EAEI,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAxnBZ;AA0nBY;EACI,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AAxnBhB;AA2nBY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAznBhB;;AAioBQ;EACI,qBAAA;AA9nBZ;AAuoBA;EACI,eAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAroBJ;AAuoBI;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AAroBR;;AAyoBA,yBAAA;AAGQ;EACI,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AAxoBZ;AA0oBY;EACI,qBAAA;AAxoBhB;AA0oBgB;EACI,2BAAA;AAxoBpB;AA0oBoB;EACI,mCAAA;EACA,iBAAA;EACA,uBAAA;AAxoBxB;AA2oBoB;EACI,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAzoBxB;AA4oBoB;EACI,aAAA;AA1oBxB;AA4oBwB;EACI,sBAAA;EACA,uBAAA;EACA,8BAAA;AA1oB5B;;AAmpBA;EACI,aAAA;EACA,yBAAA;AAhpBJ;;AAmpBA;EAIgB;IACI,qBAAA;EAnpBlB;EAspBsB;IACI,aAAA;IACA,mBAAA;EAppB1B;EAspB0B;IACI,sBAAA;EAppB9B;EAupB0B;IACI,sBAAA;EArpB9B;EAwpB0B;IACI,4BAAA;EAtpB9B;AACF;AA+pBA;EAIgB;IACI,qBAAA;EAhqBlB;EAmqBsB;IACI,aAAA;IACA,mBAAA;EAjqB1B;EAmqB0B;IACI,sBAAA;EAjqB9B;EAoqB0B;IACI,sBAAA;EAlqB9B;EAqqB0B;IACI,4BAAA;EAnqB9B;AACF;AAsrBI;EACI,6BAAA;EACA,4BAAA;AAprBR;AAurBI;EACI,6BAAA;AArrBR;;AAyrBA;EACI,cAAA;AAtrBJ;;AAksBA;EACI,wBAAA;EACA,2BAAA;AA/rBJ;;AAksBA;EACI,WAAA;AA/rBJ;;AAksBA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;AA/rBJ;;AAksBA;EACI,kBAAA;EAGA,qBAAA;EACA,qFAAA;AAjsBJ;;AAosBA;;;EAGI,0BAAA;AAjsBJ;;AAosBA;EACI,0BAAA;AAjsBJ;;AAosBA;EACI,eAAA;AAjsBJ;;AAosBA;EACI,aAAA;AAjsBJ;;AAosBA;EACI,aAAA;EACA,mBAAA;AAjsBJ;;AAosBA;EACI,mBAAA;AAjsBJ;;AAosBA;EACI,YAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAlsBJ;;AAssBI;EACI,qBAAA;AAnsBR;AAssBI;EACI,YAAA;EACA,gBAAA;AApsBR;AA6sBI;EACI,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA3sBR;AA6sBQ;EACI,WAAA;AA3sBZ;AA8sBQ;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA5sBZ;AA8sBY;EACI,uBAAA;AA5sBhB;AAitBQ;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AA/sBZ;AAitBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA/sBhB;AAktBY;EACI,iBAAA;EACA,uBAAA;EACA,WAAA;AAhtBhB;AAotBQ;EACI,WAAA;EACA,wBAAA;EACA,6BAAA;AAltBZ;AAqtBQ;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AAntBZ;;AAwtBA;EAEQ;IACI,qBAAA;IACA,iBAAA;EAttBV;EAytBM;IACI,yBAAA;IACA,qBAAA;IACA,qBAAA;EAvtBV;EA6tBM;IACI,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EA3tBV;EA6tBU;IACI,WAAA;EA3tBd;EA8tBU;IACI,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA5tBd;EA+tBU;IACI,0BAAA;IACA,sBAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;IACA,0BAAA;EA7tBd;EA+tBc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EA7tBlB;EAguBc;IACI,iBAAA;IACA,uBAAA;IACA,WAAA;EA9tBlB;EAkuBU;IACI,WAAA;IACA,wBAAA;IACA,6BAAA;EAhuBd;EAmuBU;IACI,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EAjuBd;AACF;AAsuBA;EAEQ;IACI,qBAAA;IACA,iBAAA;EAruBV;EAwuBM;IACI,yBAAA;IACA,qBAAA;IACA,qBAAA;EAtuBV;EA4uBM;IACI,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EA1uBV;EA4uBU;IACI,WAAA;EA1uBd;EA6uBU;IACI,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA3uBd;EA8uBU;IACI,0BAAA;IACA,sBAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EA5uBd;EA8uBc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EA5uBlB;EA+uBc;IACI,iBAAA;IACA,uBAAA;IACA,WAAA;EA7uBlB;EAivBU;IACI,WAAA;IACA,wBAAA;IACA,6BAAA;EA/uBd;EAkvBU;IACI,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EAhvBd;EAqvBE;IACI,kBAAA;EAnvBN;AACF;AAsvBA;EAEQ;IACI,qBAAA;IACA,iBAAA;EArvBV;EAwvBM;IACI,2BAAA;IACA,uBAAA;IACA,UAAA;EAtvBV;EAgwBM;IACI,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EA9vBV;EAgwBU;IACI,WAAA;EA9vBd;EAiwBU;IACI,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA/vBd;EAkwBU;IACI,WAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EAhwBd;EAkwBc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAhwBlB;EAmwBc;IACI,iBAAA;IACA,uBAAA;IACA,WAAA;EAjwBlB;EAowBc;IACI,0BAAA;IACA,sBAAA;EAlwBlB;EAswBU;IACI,WAAA;IACA,wBAAA;IACA,6BAAA;EApwBd;EAuwBU;IACI,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EArwBd;EA0wBE;IACI,kBAAA;EAxwBN;AACF;AA2wBA;EAEQ;IACI,qBAAA;IACA,iBAAA;EA1wBV;EA6wBM;IACI,yBAAA;IACA,qBAAA;IACA,UAAA;EA3wBV;EAqxBM;IACI,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EAnxBV;EAqxBU;IACI,WAAA;EAnxBd;EAsxBU;IACI,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EApxBd;EAuxBU;IACI,WAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EArxBd;EAuxBc;IACI,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EArxBlB;EAwxBc;IACI,iBAAA;IACA,uBAAA;IACA,WAAA;EAtxBlB;EAyxBc;IACI,0BAAA;IACA,sBAAA;EAvxBlB;EA2xBU;IACI,WAAA;IACA,wBAAA;IACA,6BAAA;EAzxBd;EA4xBU;IACI,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA1xBd;EA+xBE;IACI,iBAAA;EA7xBN;AACF;AA6yBA;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;AA3yBJ;AA6yBI;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA3yBR;;AAozBI;EACI,OAAA;AAjzBR;;AAqzBA,oCAAA;AAGQ;EACI,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AApzBZ;AAszBY;EACI,qBAAA;AApzBhB;AAszBgB;EACI,2BAAA;AApzBpB;AAszBoB;EACI,mCAAA;EACA,iBAAA;EACA,uBAAA;AApzBxB;AAuzBoB;EACI,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AArzBxB;AAwzBoB;EACI,aAAA;AAtzBxB;AAwzBwB;EACI,sBAAA;EACA,uBAAA;EACA,8BAAA;AAtzB5B;;AA+zBA;EAIgB;IACI,qBAAA;EA/zBlB;EAk0BsB;IACI,aAAA;IACA,mBAAA;EAh0B1B;EAk0B0B;IACI,sBAAA;EAh0B9B;EAm0B0B;IACI,sBAAA;EAj0B9B;EAo0B0B;IACI,4BAAA;EAl0B9B;AACF;AA20BA;EAIgB;IACI,qBAAA;EA50BlB;EA+0BsB;IACI,aAAA;IACA,mBAAA;EA70B1B;EA+0B0B;IACI,sBAAA;EA70B9B;EAg1B0B;IACI,sBAAA;EA90B9B;EAi1B0B;IACI,4BAAA;EA/0B9B;AACF;AAw1BA;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAt1BJ;AAw1BI;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAt1BR;;AA41BQ;EACI,aAAA;AAz1BZ;AA21BY;EACI,sCAAA;AAz1BhB;;AAq2BI;EACI,OAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;AAl2BR;;AAw2BQ;EACI,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AAr2BZ;AAu2BY;EACI,qBAAA;AAr2BhB;AAu2BgB;EACI,2BAAA;AAr2BpB;AAu2BoB;EACI,mCAAA;EACA,iBAAA;EACA,uBAAA;AAr2BxB;AAw2BoB;EACI,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAt2BxB;AAy2BoB;EACI,aAAA;AAv2BxB;AAy2BwB;EACI,sBAAA;EACA,uBAAA;EACA,8BAAA;AAv2B5B;;AAg3BA;EAIgB;IACI,qBAAA;EAh3BlB;EAm3BsB;IACI,aAAA;IACA,mBAAA;EAj3B1B;EAm3B0B;IACI,sBAAA;EAj3B9B;EAo3B0B;IACI,sBAAA;EAl3B9B;EAq3B0B;IACI,4BAAA;EAn3B9B;AACF;AA43BA;EAIgB;IACI,qBAAA;EA73BlB;EAg4BsB;IACI,aAAA;IACA,mBAAA;EA93B1B;EAg4B0B;IACI,sBAAA;EA93B9B;EAi4B0B;IACI,sBAAA;EA/3B9B;EAk4B0B;IACI,4BAAA;EAh4B9B;AACF;AAy4BA;EACI;IACI,sBAAA;EAv4BN;EA04BE;IACI,sBAAA;IACA,2BAAA;EAx4BN;EA24BE;IACI,YAAA;IACA,iBAAA;EAz4BN;AACF;AA44BA;EACI;IACI,YAAA;IACA,WAAA;IACA,2BAAA;IACA,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,sBAAA;EA14BN;EA44BM;IACI,YAAA;IACA,gCAAA;EA14BV;EA44BU;IACI,WAAA;EA14Bd;EA+4BE;IACI,kBAAA;IACA,UAAA;EA74BN;AACF;AAu5BA;EACI,0BAAA;EACA,sBAAA;EACA,qCAAA;EACA,iBAAA;AAr5BJ;;AAw5BA;EACI,0BAAA;EACA,sBAAA;AAr5BJ;;AAw5BA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;AAr5BJ;AAu5BI;EACI,aAAA;AAr5BR;AAw5BI;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AAt5BR;AAy5BI;EACI,aAAA;EACA,eAAA;EACA,WAAA;AAv5BR;AAy5BQ;EACI,sCAAA;EACA,kBAAA;AAv5BZ;;AA45BA;EACI,cAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AAz5BJ;AA25BI;EACI,sCAAA;AAz5BR;AA25BQ;EACI,cAAA;AAz5BZ;;AA85BA;EACI,mBAAA;AA35BJ;;AA85BA;EACI,uBAAA;EACA,kBAAA;EAEA,YAAA;EAEA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,sCAAA;EACA,qCAAA;AA35BJ;;AA85BA;EACI,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA35BJ;AA65BI;EACI,sBAAA;AA35BR;;AA+5BA;EACI,qBAAA;AA55BJ;;AAw6BA;EACI;IACI,oCAAA;IACA,4BAAA;EAr6BN;EAu6BM;IACI,0BAAA;EAr6BV;EAy6BE;IACI,8BAAA;EAv6BN;EA06BE;IACI,2BAAA;EAx6BN;AACF;AA46BI;EACI,kBAAA;AA16BR;AA46BQ;EACI,kBAAA;AA16BZ;;AA+6BA,iBAAA;AACA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EAEA,iBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,mBAAA;AA96BJ;AAg7BI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AA96BR;AAi7BI;EACI,iBAAA;EACA,WAAA;AA/6BR;AAk7BY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAh7BhB;AAo7BgB;EACI,WAAA;AAl7BpB;AAs7BY;EACI,WAAA;EACA,mBAAA;AAp7BhB;AAs7BgB;EACI,sBAAA;EACA,0BAAA;EACA,8BAAA;AAp7BpB;AAu7BgB;EACI,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAr7BpB;AAy7BY;EACI,mBAAA;AAv7BhB;AA07BY;EACI,aAAA;EACA,eAAA;AAx7BhB;AA07BgB;EACI,WAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;AAx7BpB;AA07BoB;EACI,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAx7BxB;AA07BwB;EACI,sBAAA;AAx7B5B;AAg8BI;EACI,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,OAAA;EACA,mBAAA;AA/7BR;AAi8BQ;EACI,WAAA;AA/7BZ;AAm8BI;EACI,mBAAA;EACA,iBAAA;EACA,WAAA;AAj8BR;AAm8BQ;;EAEI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AAj8BZ;AAm8BY;;EACI,sBAAA;AAh8BhB;AAm8BY;;EACI,WAAA;EACA,+BAAA;EAEA,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAj8BhB;AAq8BQ;EACI,aAAA;EACA,yBAAA;EACA,YAAA;AAn8BZ;AAq8BY;EACI,aAAA;AAn8BhB;AAw8BI;EACI,WAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAt8BR;AAw8BQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;AAt8BZ;AAw8BY;EACI,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AAt8BhB;AAy8BY;EACI,kBAAA;EACA,UAAA;AAv8BhB;AA48BQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA18BZ;;AA+8BA;EAKI,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAh9BJ;;AAq9BA;EACI,gBAAA;EACA,UAAA;EACA,aAAA;EAGA,aAAA;EACA,WAAA;EACA,aAAA;AAp9BJ;;AAu9BA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAp9BJ;AAw9BI;EACI,WAAA;AAt9BR;;AA29BA;EACI,aAAA;AAx9BJ;;AA29BA;EACI,iBAAA;AAx9BJ;AA09BI;EAEI,uBAAA;AAz9BR;AA49BI;EACI,iBAAA;AA19BR;;AA89BA;EACI;IACI,eAAA;IACA,WAAA;IACA,UAAA;IACA,aAAA;IACA,aAAA;IACA,qBAAA;IACA,gBAAA;IACA,sBAAA;IACA,iDAAA;IACA,yBAAA;IACA,gCAAA;IACA,eAAA;IACA,WAAA;IACA,sBAAA;IACA,aAAA;IACA,eAAA;IACA,gBAAA;IACA,8CAAA;IACA,gBAAA;IACA,kCAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EA39BN;AACF;AA+9BA;EACI,aAAA;EACA,SAAA;AA79BJ;;AAg+BA,0BAAA;AACA;EACI,WAAA;AA79BJ;;AAk+BA;EACI,mBAAA;EACA,kBAAA;AA/9BJ;;AAk+BA;EACI,iBAAA;EAEA,YAAA;EACA,eAAA;AAh+BJ;;AAm+BA;EAEI,0CAAA;AAj+BJ;;AAo+BA,wBAAA;AACA;EACI,WAAA;EACA,kBAAA;AAj+BJ;;AAo+BA;EACI,mBAAA;AAj+BJ;;AAo+BA;;EAEI,cAAA;EACA,gBAAA;EACA,kBAAA;AAj+BJ;;AAq+BI;EACI,WAAA;AAl+BR;AAq+BI;EACI,WAAA;AAn+BR;;AAu+BA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AAp+BJ;;AAu+BA;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAp+BJ;AAs+BI;EACI,mBAAA;EACA,8BAAA;AAp+BR;;AAw+BA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAr+BJ;;AAy+BA;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAt+BJ;AA0+BQ;EACI,sBAAA;AAx+BZ;AA0+BY;EACI,aAAA;AAx+BhB;AA2+BY;EACI,eAAA;AAz+BhB;AA6+BQ;EACI,wBAAA;EACA,sBAAA;EACA,sBAAA;AA3+BZ;AAg/BQ;EACI,sBAAA;AA9+BZ;AAg/BY;EAEI,eAAA;AA/+BhB;AAk/BY;EACI,eAAA;AAh/BhB;AAo/BQ;EACI,wBAAA;EACA,sBAAA;EACA,sBAAA;AAl/BZ;;AAu/BA;;EAGI,sBAAA;EACA,sBAAA;EACA,sCAAA;AAr/BJ;;AAw/BA;EACI,wBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAr/BJ;;AAw/BA;EACI,gDAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mCAAA;EACA,oCAAA;EACA,qBAAA;EACA,WAAA;EACA,qCAAA;AAr/BJ;;AAw/BA;;EAEI,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AAr/BJ;;AAy/BA;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAt/BJ;;AAy/BA;EACI,aAAA;EACA,iBAAA;AAt/BJ;;AAy/BA;EACI,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AAt/BJ;AAw/BI;EACI,6BAAA;AAt/BR;AAy/BI;EACI,8BAAA;AAv/BR;;AA4/BA;EACI,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,yCAAA;EACA,gBAAA;EACA,4CAAA;AAz/BJ;;AA6/BA;EACI,eAAA;EACA,oCAAA;EACA,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,2BAAA;AA1/BJ;;AA6/BA;EACI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,8BAAA;EACA,iCAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;AA1/BJ;;AA6/BA;EACI,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,wCAAA;AA1/BJ;;AA8/BA;EACI,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,oCAAA;AA3/BJ;;AA8/BA;EACI,eAAA;EACA,kCAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,yCAAA;EACA,cAAA;EACA,8DAAA;AA3/BJ;;AA8/BA;EACI,eAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;EACA,sBAAA;EACA,oBAAA;AA3/BJ;;AA8/BA;EACI,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,0CAAA;EACA,uBAAA;EACA,iDAAA;EACA,eAAA;EACA,wDAAA;AA3/BJ;;AA8/BA,+EAAA;AACA;EACI,gBAAA;EACA,uCAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,+CAAA;AA3/BJ;;AA8/BA,uDAAA;AACA;EACI,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AA3/BJ;;AA8/BA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;AA3/BJ;;AA8/BA;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AA3/BJ;;AA8/BA;EACI,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AA3/BJ;;AA8/BA;2EAAA","sourcesContent":["// Wrapper for the reported flow modal content\n.reported-flow-dialog {\n  // Phone-like width: match mobile view-flow column, centered in viewport\n  width: 100%;\n  max-width: 480px; /* Match mobile viewflow width */\n  max-height: 90vh;\n  padding: 0;\n  margin: 0 auto;\n  box-sizing: border-box;\n  background: #ffffff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  // Allow the whole modal to scroll vertically when content is taller than viewport\n  overflow-y: auto;\n  overflow-x: visible; // allow inner horizontal scrollbars (e.g., flow-info-panel) to show\n  display: flex;\n  flex-direction: column;\n\n  .dialog-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px;\n    border-bottom: 1px solid #e2e8f0;\n    background: #ffffff;\n\n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 700;\n      color: #0f172a;\n    }\n\n    .close-btn {\n      color: #64748b;\n    }\n  }\n\n  .dialog-content {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n\n    // Tweak viewflow inside dialog so it behaves nicely (no full-page height)\n    .view-flow {\n      min-height: auto !important; // override 100vh from main page so it fits dialog\n      background: transparent !important; // Remove background so mobile styles apply\n    }\n\n    // Skeleton loader styles - ensure proper width and layout\n    .skeleton-viewflow-container {\n      --skeleton-gradient: linear-gradient(\n        110deg,\n        #f6f7f8 8%,\n        #eceef1 18%,\n        #f6f7f8 33%\n      );\n      width: 100%;\n      background: #efeeee;\n      padding: 0;\n      margin: 0;\n      min-height: auto;\n\n      .container1 {\n        max-width: 100%;\n        width: 100%;\n        margin: 0;\n        padding: 0;\n        background: transparent;\n\n        .flow-layout-container {\n          width: 100%;\n          padding: 0;\n          margin: 0;\n\n          .flow-main-grid {\n            display: grid;\n            grid-template-columns: 1fr; // Single column for mobile layout\n            gap: 12px;\n            max-width: 100%;\n            margin: 0;\n            padding: 12px;\n            background: transparent;\n          }\n\n          .flow-main-content {\n            width: 100%;\n            max-width: 100%;\n          }\n        }\n      }\n\n      // Skeleton element styles\n      .skeleton-text,\n      .skeleton-avatar,\n      .skeleton-icon,\n      .skeleton-image {\n        background-image: var(--skeleton-gradient);\n        background-size: 220% 100%;\n        animation: skeleton-shimmer 1.35s linear infinite,\n          skeleton-pulse 2s ease-in-out infinite;\n        background-color: #e0e0e0;\n      }\n\n      .skeleton-text {\n        border-radius: 4px;\n        height: 16px;\n        margin: 6px 0;\n        display: block;\n\n        &.skeleton-title {\n          height: 24px;\n          width: 60%;\n        }\n\n        &.skeleton-subtitle {\n          height: 16px;\n          width: 40%;\n        }\n\n        &.skeleton-badge-text {\n          height: 14px;\n          width: 80px;\n        }\n\n        &.short {\n          width: 40%;\n        }\n\n        &.skeleton-description {\n          height: 14px;\n          width: 100%;\n          margin: 8px 0;\n\n          &.short {\n            width: 70%;\n          }\n        }\n\n        &.skeleton-action-text {\n          height: 14px;\n          width: 60px;\n          margin: 0;\n        }\n\n        &.skeleton-step-circle {\n          width: 32px;\n          height: 32px;\n          border-radius: 50%;\n          margin-right: 12px;\n          flex-shrink: 0;\n        }\n\n        &.skeleton-step-title {\n          height: 24px;\n          width: 70%;\n        }\n      }\n\n      .skeleton-avatar {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        margin-right: 10px;\n        flex-shrink: 0;\n\n        &.skeleton-channel-avatar {\n          width: 48px;\n          height: 48px;\n        }\n      }\n\n      .skeleton-icon {\n        width: 24px;\n        height: 24px;\n        border-radius: 4px;\n        margin-right: 8px;\n        flex-shrink: 0;\n\n        &.skeleton-share-icon {\n          width: 20px;\n          height: 20px;\n          margin-left: auto;\n          margin-right: 0;\n        }\n      }\n\n      .skeleton-image {\n        width: 100%;\n        height: 0;\n        padding-bottom: 56.25%; // 16:9 aspect ratio\n        border-radius: 12px;\n        position: relative;\n        overflow: hidden;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          background-image: var(--skeleton-gradient);\n          background-size: 220% 100%;\n          animation: skeleton-shimmer 1.35s linear infinite,\n            skeleton-pulse 2s ease-in-out infinite;\n          background-color: #e0e0e0;\n        }\n\n        &.large {\n          padding-bottom: 56.25%; // Maintain 16:9 aspect ratio\n        }\n      }\n\n      .skeleton-card {\n        background: #fff;\n        border-radius: 12px;\n        padding: 16px 20px;\n        margin-bottom: 16px;\n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n        width: 100%;\n        box-sizing: border-box;\n      }\n\n      .skeleton-flow-header {\n        background: #ffffff;\n        border-bottom: 1px solid #e0e0e0;\n        padding: 16px 12px 8px 12px;\n        margin-bottom: 8px;\n        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n        border-radius: 0;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        width: 100%;\n        box-sizing: border-box;\n\n        .video-title-sticky {\n          height: 28px;\n          width: 60%;\n        }\n      }\n\n      .skeleton-info-panel {\n        display: flex;\n        gap: 8px;\n        overflow-x: auto;\n        padding: 12px;\n        width: 100%;\n        box-sizing: border-box;\n\n        .info-badge {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n          padding: 8px 12px;\n          background: #f5f5f5;\n          border-radius: 20px;\n          flex-shrink: 0;\n          min-width: 80px;\n        }\n      }\n\n      .metadata-skeleton {\n        .step-header {\n          display: flex;\n          align-items: center;\n          margin-bottom: 16px;\n\n          .step-header-main {\n            display: flex;\n            align-items: center;\n            width: 100%;\n            gap: 12px;\n          }\n        }\n\n        .video-actions-bar {\n          .action-buttons {\n            display: flex;\n            gap: 16px;\n            flex-wrap: wrap;\n\n            .skeleton-action-item {\n              display: flex;\n              align-items: center;\n              gap: 6px;\n            }\n          }\n        }\n      }\n\n      .channel-info-section {\n        .channel-header {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n\n          .channel-details {\n            flex: 1;\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n          }\n        }\n      }\n\n      .description-section {\n        .description-header {\n          margin-bottom: 12px;\n        }\n\n        .description-content {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n      }\n    }\n\n    // Skeleton animations\n    @keyframes skeleton-shimmer {\n      0% {\n        background-position: -200% 0;\n      }\n      100% {\n        background-position: 200% 0;\n      }\n    }\n\n    @keyframes skeleton-pulse {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 24px 24px;\n    border-top: 1px solid #e2e8f0;\n    background: #ffffff;\n  }\n}\n\n/* (No extra reported-flow metadata overrides; we now reuse viewflow styles\n   for .video-metadata and .video-actions-bar to match mobile UI exactly.) */\n\n.container {\n    padding: 0px !important;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.box {\n    max-width: 360px;\n    width: 100% !important;\n    // max-height:90vh;\n    // min-height:77vh !important;\n    margin: 10px;\n    padding: 0px 25px;\n    background: #fff;\n    background-size: 50%;\n    background-position: top center;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n    overflow: hidden;\n    background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n    background-size: cover;\n    background-position: center;\n    border-radius: 15px 15px 0px 0px;\n    margin: 0px auto;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    background-size: 100% 90%;\n    background-position: top center;\n}\n\n.box-wrap {\n    position: relative;\n    z-index: 2;\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    padding: 30px 0px;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.box:after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n    background: rgba(0, 0, 0, 0.5);\n}\n\n* {\n    padding: 0px;\n    margin: 0px;\n}\n\nbody {\n    background: #efeeee;\n    counter-reset: my-sec-counter;\n}\n\n// Override old view-flow styles to ensure mobile viewflow layout works correctly\n.reported-flow-dialog .view-flow {\n    background: transparent !important;\n    min-height: auto !important;\n    padding-top: 0 !important;\n\n    .container1 {\n        max-width: 100% !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        background: transparent !important;\n        \n        // Force mobile layout for flow-layout-container (single column, full width)\n        .flow-layout-container {\n            width: 100% !important;\n            padding: 0 !important;\n            margin: 0 !important;\n            \n            .flow-main-grid {\n                display: grid !important;\n                grid-template-columns: 1fr !important; // Force single column (mobile layout)\n                gap: 12px !important;\n                max-width: 100% !important;\n                margin: 0 !important;\n                padding: 12px !important; // Mobile padding\n                background: transparent !important;\n                \n                // Hide sidebar in modal (mobile view)\n                .flow-sidebar {\n                    display: none !important;\n                }\n            }\n            \n            .flow-main-content {\n                width: 100% !important;\n                min-width: 0 !important;\n                max-width: 100% !important;\n                \n                // Fix vertical text issue and ensure proper mobile styling\n                .flow-title-sticky {\n                    writing-mode: horizontal-tb !important;\n                    text-orientation: mixed !important;\n                    word-break: normal !important;\n                    white-space: normal !important;\n                    display: flex !important;\n                    flex-direction: row !important;\n                    border-radius: 0 !important;\n                    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04) !important;\n                    border-bottom: 1px solid #e0e0e0 !important;\n                    padding: 16px 0 8px 0 !important;\n                    margin-bottom: 8px !important;\n                }\n                \n                .video-title-sticky {\n                    writing-mode: horizontal-tb !important;\n                    text-orientation: mixed !important;\n                    word-break: normal !important;\n                    white-space: normal !important;\n                }\n                \n                /* Make flow-info-panel in the admin modal match the video-actions-bar scroll behavior exactly */\n                .flow-info-panel {\n                    display: flex;\n                    align-items: center;\n                    gap: 8px;\n                    padding: 12px 16px;\n                    background: #ffffff;\n                    border-radius: 16px;\n                    margin-bottom: 16px;\n\n                    @media (max-width: 1024px) {\n                        background: #f9f9f9;\n                        border-radius: 8px;\n                        box-shadow: none;\n                    }\n\n                    /* Match video-actions-bar scroll behavior exactly */\n                    overflow-x: auto;\n                    overflow-y: hidden;\n                    -webkit-overflow-scrolling: touch;\n                    flex-direction: row;\n                    writing-mode: horizontal-tb;\n                    text-orientation: mixed;\n                    direction: ltr;\n\n                    &::-webkit-scrollbar {\n                        height: 6px;\n                    }\n\n                    &::-webkit-scrollbar-thumb {\n                        background: rgba(0, 0, 0, 0.2);\n                        border-radius: 4px;\n                    }\n\n                    &::-webkit-scrollbar-thumb:hover {\n                        background: rgba(0, 0, 0, 0.3);\n                    }\n\n                    .info-badge {\n                        display: inline-flex;\n                        align-items: center;\n                        gap: 6px;\n                        font-size: 13px;\n                        font-weight: 500;\n                        font-family: \"Raleway\", sans-serif;\n                        color: #0f0f0f;\n                        background: white;\n                        border: 1px solid #e0e0e0;\n                        border-radius: 16px;\n                        padding: 4px 12px;\n                        cursor: pointer;\n                        transition: all 0.2s;\n                        white-space: nowrap;\n                        flex-shrink: 0;\n                        min-width: fit-content;\n                        writing-mode: horizontal-tb;\n                        text-orientation: mixed;\n                        direction: ltr;\n                        transform: none;\n\n                        &:hover {\n                            background: #f5f5f5;\n                            border-color: #5ea1d8;\n                        }\n\n                        &.active {\n                            background: #5ea1d8;\n                            color: #0f0f0f;\n                            border-color: #5ea1d8;\n                            writing-mode: horizontal-tb;\n                            text-orientation: mixed;\n                            transform: none;\n\n                            .info-icon,\n                            .info-label,\n                            .info-step-title {\n                                color: #0f0f0f;\n                            }\n                        }\n\n                        .info-icon {\n                            font-size: 14px;\n                            flex-shrink: 0;\n                            line-height: 1;\n                        }\n\n                        .info-label {\n                            font-family: \"Raleway\", sans-serif;\n                            flex-shrink: 0;\n                            font-size: 13px;\n                        }\n\n                        .info-step-title {\n                            font-size: 12px;\n                            color: #606060;\n                            margin-left: 4px;\n                            font-weight: 400;\n                            max-width: 200px;\n                            overflow: hidden;\n                            text-overflow: ellipsis;\n                            white-space: nowrap;\n                        }\n                    }\n                }\n                \n                .video-metadata {\n                    width: 100% !important;\n                    padding: 16px 0 !important; // Match viewflow mobile: padding: 16px 0\n                    background: transparent !important; // Match viewflow mobile\n                    border-radius: 0 !important; // Match viewflow mobile\n                    box-shadow: none !important; // Match viewflow mobile\n                    margin-bottom: 16px !important;\n                    border-bottom: 1px solid #e0e0e0 !important; // Match viewflow mobile\n                    \n                    .step-header {\n                        display: flex !important;\n                        align-items: flex-start !important;\n                        gap: 16px !important;\n                        margin-bottom: 12px !important;\n                        flex-wrap: wrap !important;\n                        justify-content: space-between !important;\n                        \n                        .step-header-main {\n                            display: flex !important;\n                            align-items: center !important;\n                            gap: 12px !important;\n                            flex: 1 !important;\n                            min-width: 0 !important;\n                        }\n                    }\n                    \n                    .video-title {\n                        font-size: 20px !important; // Match viewflow\n                        font-weight: 500 !important; // Match viewflow\n                        line-height: 28px !important; // Match viewflow\n                        color: #0f0f0f !important; // Match viewflow\n                        margin: 0 !important;\n                        writing-mode: horizontal-tb !important;\n                        text-orientation: mixed !important;\n                        word-break: normal !important;\n                        white-space: normal !important;\n                    }\n                    \n                    .video-actions-bar {\n                        overflow-x: auto !important;\n                        overflow-y: hidden !important;\n                        padding: 0 16px 12px 16px !important;\n                        margin-top: 20px !important;\n                        \n                        &::-webkit-scrollbar {\n                            height: 4px !important;\n                        }\n                        \n                        &::-webkit-scrollbar-thumb {\n                            background: rgba(0, 0, 0, 0.2) !important;\n                            border-radius: 4px !important;\n                        }\n                        \n                        .action-buttons {\n                            display: flex !important;\n                            align-items: center !important;\n                            gap: 8px !important;\n                            flex-wrap: nowrap !important;\n                            width: max-content !important;\n                            \n                            .action-item {\n                                display: flex !important;\n                                align-items: center !important;\n                                gap: 6px !important;\n                                flex: 0 0 auto !important;\n                                min-width: 100px !important;\n                                padding: 6px 10px !important;\n                                border-radius: 14px !important;\n                                background: #f2f2f2 !important;\n                                cursor: pointer !important;\n                                transition: background 0.2s !important;\n                                \n                                &:hover {\n                                    background: #e5e5e5 !important;\n                                }\n                                \n                                mat-icon {\n                                    font-size: 18px !important;\n                                    width: 18px !important;\n                                    height: 18px !important;\n                                    margin: 0 !important;\n                                }\n                                \n                                span {\n                                    font-size: 13px !important;\n                                    font-weight: 500 !important;\n                                    color: #212427 !important;\n                                    white-space: nowrap !important;\n                                }\n                                \n                                .favorite-toggle-icon {\n                                    color: #000000 !important;\n                                    \n                                    &.liked {\n                                        color: #ff4d4d !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                \n                .channel-info-section {\n                    width: 100% !important;\n                    padding: 16px 0 !important; // Match viewflow mobile: padding: 16px 0\n                    background: transparent !important; // Match viewflow mobile\n                    border-radius: 0 !important; // Match viewflow mobile\n                    box-shadow: none !important; // Match viewflow mobile\n                    margin-bottom: 16px !important;\n                    border-bottom: 1px solid #e0e0e0 !important; // Match viewflow mobile\n                    \n                    .channel-header {\n                        display: flex !important;\n                        align-items: center !important;\n                        gap: 16px !important;\n                        \n                        @media (max-width: 768px) {\n                            gap: 12px !important;\n                            align-items: flex-start !important;\n                        }\n                        \n                        .channel-avatar {\n                            flex-shrink: 0 !important;\n                            \n                            img {\n                                width: 48px !important;\n                                height: 48px !important;\n                                border-radius: 50% !important;\n                                object-fit: cover !important;\n                                cursor: pointer !important;\n                                \n                                @media (max-width: 768px) {\n                                    width: 40px !important;\n                                    height: 40px !important;\n                                }\n                            }\n                            \n                            .material-icons {\n                                font-size: 48px !important;\n                                width: 48px !important;\n                                height: 48px !important;\n                                color: #606060 !important;\n                                cursor: pointer !important;\n                                \n                                @media (max-width: 768px) {\n                                    font-size: 40px !important;\n                                    width: 40px !important;\n                                    height: 40px !important;\n                                }\n                            }\n                        }\n                        \n                        .channel-details {\n                            flex: 1 !important;\n                            min-width: 0 !important;\n                            max-width: 100% !important;\n                            text-align: left !important; // Ensure left alignment\n                            display: flex !important;\n                            flex-direction: column !important;\n                            align-items: flex-start !important; // Left align all children\n                            \n                            .channel-name {\n                                font-size: 16px !important; // Match viewflow\n                                font-weight: 500 !important; // Match viewflow\n                                color: #0f0f0f !important; // Match viewflow\n                                cursor: pointer !important;\n                                margin-bottom: 4px !important;\n                                white-space: nowrap !important;\n                                overflow: hidden !important;\n                                text-overflow: ellipsis !important;\n                                width: 100% !important;\n                                text-align: left !important; // Explicit left alignment\n                                writing-mode: horizontal-tb !important;\n                                text-orientation: mixed !important;\n                                word-break: normal !important;\n                                align-self: flex-start !important; // Left align\n                                \n                                @media (max-width: 768px) {\n                                    font-size: 15px !important;\n                                    margin-bottom: 6px !important;\n                                }\n                                \n                                &:hover {\n                                    color: #606060 !important;\n                                }\n                            }\n                            \n                            .channel-meta {\n                                display: flex !important;\n                                align-items: center !important;\n                                justify-content: flex-start !important; // Left align content\n                                gap: 8px !important;\n                                flex-wrap: wrap !important;\n                                font-size: 14px !important;\n                                color: #606060 !important;\n                                line-height: 1.4 !important;\n                                margin-top: 2px !important;\n                                width: 100% !important;\n                                text-align: left !important; // Explicit left alignment\n                                align-self: flex-start !important; // Left align\n                                \n                                span {\n                                    display: inline-flex !important;\n                                    align-items: center !important;\n                                    gap: 4px !important;\n                                    white-space: nowrap !important;\n                                    line-height: 1.4 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n                \n                .description-section {\n                    width: 100% !important;\n                    padding: 16px !important; // Match viewflow mobile\n                    background: #f9f9f9 !important; // Match viewflow mobile: background: #f9f9f9\n                    border-radius: 12px !important; // Match viewflow mobile: border-radius: 12px\n                    box-shadow: none !important; // Match viewflow mobile\n                    margin-bottom: 16px !important;\n                    \n                    .description-header {\n                        display: flex !important;\n                        align-items: center !important;\n                        justify-content: space-between !important;\n                        margin-bottom: -16px !important; // Match viewflow\n                        position: relative !important;\n                        \n                        h3 {\n                            font-size: 16px !important; // Match viewflow\n                            font-weight: 500 !important; // Match viewflow\n                            color: #0f0f0f !important; // Match viewflow\n                            margin: 0 !important;\n                            display: flex !important;\n                            align-items: center !important;\n                            gap: 12px !important;\n                            flex: 1 !important;\n                            writing-mode: horizontal-tb !important;\n                            text-orientation: mixed !important;\n                            word-break: normal !important;\n                            white-space: normal !important;\n                        }\n                    }\n                    \n                    .description-content {\n                        margin-top: 16px !important;\n                        \n                        // Description collapse/expand styles\n                        .description-collapsed {\n                            max-height: 60px !important;\n                            overflow: hidden !important;\n                            transition: max-height 0.3s ease !important;\n                        }\n                        \n                        > div:not(.description-collapsed) {\n                            max-height: none !important;\n                            overflow: visible !important;\n                        }\n                    }\n                    \n                    .show-more-button {\n                        margin-top: 8px !important;\n                        background: none !important;\n                        border: none !important;\n                        color: #606060 !important;\n                        font-size: 14px !important;\n                        font-weight: 500 !important;\n                        cursor: pointer !important;\n                        padding: 0 !important;\n                        \n                        &:hover {\n                            color: #0f0f0f !important;\n                        }\n                    }\n                }\n                \n                // Customer Feedback Section (Reviews) - Match viewflow mobile\n                app-customer-feedback-section {\n                    width: 100% !important;\n                    padding: 0 !important;\n                    display: block !important;\n                    margin-top: 0 !important;\n                    margin-bottom: 16px !important;\n                }\n                \n                // Comments Section - Match viewflow mobile exactly\n                .comments-section {\n                    width: 100% !important;\n                    padding: 16px 0 !important; // Match viewflow mobile: padding: 16px 0 (no left/right padding since grid has it)\n                    background: transparent !important; // Match viewflow mobile\n                    border-radius: 0 !important; // Match viewflow mobile\n                    box-shadow: none !important; // Match viewflow mobile\n                    margin-bottom: 16px !important;\n                    margin-top: 0 !important;\n                    display: block !important;\n                    \n                    h3 {\n                        font-size: 16px !important; // Match viewflow: font-size: 16px\n                        font-weight: 500 !important; // Match viewflow: font-weight: 500\n                        color: #0f0f0f !important; // Match viewflow: color: #0f0f0f\n                        margin-bottom: 24px !important; // Match viewflow: margin-bottom: 24px\n                        margin-top: 0 !important;\n                    }\n                    \n                    .comment-input-section {\n                        display: flex !important;\n                        gap: 16px !important; // Match viewflow: gap: 16px\n                        margin-bottom: 32px !important; // Match viewflow: margin-bottom: 32px\n                        \n                        .comment-avatar {\n                            flex-shrink: 0 !important;\n                            \n                            img {\n                                width: 40px !important;\n                                height: 40px !important;\n                                border-radius: 50% !important;\n                                object-fit: cover !important;\n                            }\n                            \n                            .material-icons {\n                                font-size: 40px !important;\n                                width: 40px !important;\n                                height: 40px !important;\n                                color: #606060 !important; // Match viewflow: color: #606060\n                            }\n                        }\n                        \n                        .comment-form-wrapper {\n                            flex: 1 !important;\n                            position: relative !important;\n                            \n                            form {\n                                display: flex !important;\n                                align-items: center !important;\n                                gap: 8px !important;\n                            }\n                            \n                            .comment-input {\n                                flex: 1 !important;\n                                padding: 8px 0 !important; // Match viewflow: padding: 8px 0\n                                border: none !important;\n                                border-bottom: 1px solid #e0e0e0 !important; // Match viewflow\n                                font-size: 14px !important;\n                                color: #0f0f0f !important;\n                                background: transparent !important;\n                                \n                                &:focus {\n                                    outline: none !important;\n                                    border-bottom-color: #5ea1d8 !important; // Match viewflow\n                                }\n                                \n                                &::placeholder {\n                                    color: #909090 !important; // Match viewflow\n                                }\n                            }\n                            \n                            .comment-send-btn {\n                                flex-shrink: 0 !important;\n                                background: transparent !important; // Match viewflow\n                                border: none !important;\n                                color: #5ea1d8 !important; // Match viewflow\n                                cursor: pointer !important;\n                                padding: 8px !important;\n                                display: flex !important;\n                                align-items: center !important;\n                                justify-content: center !important;\n                                border-radius: 50% !important;\n                                transition: all 0.2s !important;\n                                \n                                &:hover:not(:disabled) {\n                                    background: #f0f0f0 !important; // Match viewflow\n                                    color: #4a8fc4 !important;\n                                }\n                                \n                                &:disabled {\n                                    color: #ccc !important; // Match viewflow\n                                    cursor: not-allowed !important;\n                                }\n                                \n                                mat-icon {\n                                    font-size: 20px !important;\n                                    width: 20px !important;\n                                    height: 20px !important;\n                                }\n                            }\n                        }\n                    }\n                    \n                    .comment-login-prompt {\n                        padding: 16px !important;\n                        background: #f9f9f9 !important; // Match viewflow\n                        border-radius: 8px !important; // Match viewflow\n                        text-align: center !important;\n                        \n                        p {\n                            margin: 0 !important;\n                            font-size: 14px !important;\n                            color: #606060 !important; // Match viewflow\n                            \n                            a {\n                                color: #5ea1d8 !important;\n                                cursor: pointer !important;\n                                text-decoration: none !important;\n                                \n                                &:hover {\n                                    text-decoration: underline !important; // Match viewflow\n                                }\n                            }\n                        }\n                    }\n                    \n                    .comments-list {\n                        margin-top: 24px !important; // Match viewflow\n                        \n                        .comment-item {\n                            display: flex !important;\n                            flex-direction: column !important;\n                            padding: 16px 0 !important; // Match viewflow\n                            border-bottom: 1px solid #e0e0e0 !important; // Match viewflow\n                            \n                            &:last-child {\n                                border-bottom: none !important;\n                            }\n                            \n                            .comment-header {\n                                display: flex !important;\n                                align-items: center !important;\n                                justify-content: space-between !important;\n                                margin-bottom: 8px !important; // Match viewflow\n                                \n                                .comment-author {\n                                    display: flex !important;\n                                    align-items: center !important;\n                                    gap: 8px !important;\n                                    \n                                    .comment-avatar-img {\n                                        width: 40px !important; // Match viewflow\n                                        height: 40px !important;\n                                        border-radius: 50% !important;\n                                        object-fit: cover !important;\n                                    }\n                                    \n                                    .comment-avatar-icon {\n                                        font-size: 40px !important; // Match viewflow\n                                        width: 40px !important;\n                                        height: 40px !important;\n                                        color: #606060 !important; // Match viewflow\n                                    }\n                                    \n                                    .comment-author-name {\n                                        font-size: 14px !important;\n                                        font-weight: 500 !important; // Match viewflow\n                                        color: #0f0f0f !important; // Match viewflow\n                                        font-family: \"Raleway\", sans-serif !important;\n                                    }\n                                }\n                                \n                                .comment-date {\n                                    font-size: 12px !important;\n                                    color: #606060 !important; // Match viewflow\n                                    font-family: \"Raleway\", sans-serif !important;\n                                }\n                            }\n                            \n                            .comment-text {\n                                font-size: 14px !important;\n                                line-height: 20px !important; // Match viewflow\n                                color: #0f0f0f !important; // Match viewflow\n                                margin-bottom: 8px !important;\n                                font-family: \"Raleway\", sans-serif !important;\n                            }\n                            \n                            .comment-actions {\n                                display: flex !important;\n                                align-items: center !important;\n                                gap: 16px !important;\n                                flex-wrap: nowrap !important;\n                                overflow-x: auto !important;\n                                overflow-y: hidden !important;\n                                -ms-overflow-style: none !important;\n                                scrollbar-width: thin !important;\n                                \n                                &::-webkit-scrollbar {\n                                    height: 6px !important;\n                                }\n                                \n                                &::-webkit-scrollbar-thumb {\n                                    background: rgba(0, 0, 0, 0.2) !important;\n                                    border-radius: 4px !important;\n                                }\n                                \n                                .comment-action-btn {\n                                    display: flex !important;\n                                    align-items: center !important;\n                                    gap: 4px !important;\n                                    background: transparent !important;\n                                    border: none !important;\n                                    cursor: pointer !important;\n                                    padding: 4px 8px !important;\n                                    border-radius: 4px !important;\n                                    transition: background 0.2s !important;\n                                    color: #606060 !important;\n                                    \n                                    &:hover {\n                                        background: #f0f0f0 !important;\n                                    }\n                                    \n                                    &.liked {\n                                        color: #ff4d4d !important;\n                                    }\n                                    \n                                    mat-icon {\n                                        font-size: 18px !important;\n                                        width: 18px !important;\n                                        height: 18px !important;\n                                    }\n                                    \n                                    .like-count {\n                                        font-size: 12px !important;\n                                        font-weight: 500 !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    \n                    .no-comments {\n                        padding: 32px 16px !important;\n                        text-align: center !important;\n                        color: #606060 !important;\n                        font-size: 14px !important;\n                        \n                        p {\n                            margin: 0 !important;\n                        }\n                    }\n                }\n                \n                .video-player-section {\n                    width: 100% !important;\n                    padding: 0 !important;\n                }\n            }\n        }\n        \n        // Ensure recommendations-section-mobile matches viewflow mobile style exactly\n        .recommendations-section-mobile {\n            margin-top: 24px !important; // Match viewflow\n            padding-top: 24px !important; // Match viewflow\n            border-top: 1px solid #e0e0e0 !important; // Match viewflow\n            width: 100% !important;\n            padding-left: 0 !important; // No extra padding, grid already has it\n            padding-right: 0 !important; // No extra padding, grid already has it\n            padding-bottom: 0 !important;\n            display: block !important;\n            visibility: visible !important;\n            opacity: 1 !important;\n            \n            h2 {\n                font-size: 18px !important; // Match viewflow: font-size: 18px\n                font-weight: 500 !important; // Match viewflow: font-weight: 500\n                color: #0f0f0f !important; // Match viewflow: color: #0f0f0f\n                margin-bottom: 16px !important; // Match viewflow\n                margin-top: 0 !important;\n                display: block !important;\n                visibility: visible !important;\n            }\n            \n            .recommendations-list {\n                display: flex !important;\n                flex-direction: column !important;\n                gap: 12px !important; // Match viewflow: gap: 12px\n                overflow-x: hidden !important; // Match viewflow\n                visibility: visible !important;\n                opacity: 1 !important;\n            }\n            \n            .recommendation-item {\n                display: flex !important;\n                gap: 12px !important;\n                cursor: pointer !important;\n                padding: 12px !important; // Match viewflow\n                border-radius: 8px !important; // Match viewflow: border-radius: 8px\n                transition: background 0.2s !important; // Match viewflow\n                overflow: hidden !important; // Match viewflow\n                background: #f9f9f9 !important; // Match viewflow: background: #f9f9f9\n                border: none !important;\n                visibility: visible !important;\n                opacity: 1 !important;\n                \n                &:hover {\n                    background: #f0f0f0 !important; // Match viewflow\n                }\n            }\n            \n            .recommendation-thumbnail {\n                flex-shrink: 0 !important;\n                width: 168px !important; // Match viewflow: width: 168px\n                height: 94px !important; // Match viewflow: height: 94px\n                border-radius: 4px !important; // Match viewflow: border-radius: 4px\n                overflow: hidden !important;\n                background: #000 !important; // Match viewflow: background: #000\n                \n                img, video {\n                    width: 100% !important;\n                    height: 100% !important;\n                    object-fit: cover !important;\n                }\n            }\n            \n            .recommendation-info {\n                flex: 1 !important;\n                min-width: 0 !important;\n                \n                .recommendation-title {\n                    font-size: 14px !important; // Match viewflow\n                    font-weight: 500 !important; // Match viewflow: font-weight: 500\n                    color: #0f0f0f !important; // Match viewflow: color: #0f0f0f\n                    margin: 0 0 4px 0 !important; // Match viewflow\n                    line-height: 20px !important; // Match viewflow\n                    white-space: normal !important; // Match viewflow\n                    word-break: break-word !important; // Match viewflow\n                    overflow: hidden !important;\n                }\n                \n                .recommendation-meta {\n                    display: flex !important;\n                    flex-direction: column !important; // Match viewflow: flex-direction: column\n                    gap: 2px !important; // Match viewflow: gap: 2px\n                    font-size: 12px !important;\n                    color: #606060 !important; // Match viewflow: color: #606060\n                    flex-wrap: wrap !important;\n                    \n                    .recommendation-creator {\n                        color: #606060 !important; // Match viewflow\n                    }\n                    \n                    .recommendation-id {\n                        color: #909090 !important; // Match viewflow: color: #909090\n                    }\n                }\n                \n                .recommendation-price {\n                    display: block !important; // Match viewflow\n                    margin-top: 4px !important; // Match viewflow\n                    font-size: 14px !important; // Match viewflow\n                    font-weight: 500 !important; // Match viewflow: font-weight: 500\n                    color: #e83e8c !important; // Match viewflow: color: #e83e8c\n                }\n            }\n        }\n    }\n}\n\n// Top-level style for recommendations-section-mobile to ensure visibility\n.reported-flow-dialog .recommendations-section-mobile {\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    width: 100% !important;\n}\n\n.view-flow {\n    background: #efeeee;\n    min-height: 89vh;\n    padding-top: 10px;\n\n    .container1 {\n        max-width: 1040px;\n        margin: 0px auto;\n        background: transparent;\n        padding-bottom: 30px;\n        padding: 0px 40px 20px;\n\n        .user-sec {\n            display: flex;\n            padding: 20px 20px;\n            background: #fff;\n            border: 1px solid #ddd;\n            box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n            margin: 0px 20px 0px 20px;\n            border-radius: 10px;\n            position: relative;\n\n            .user-details {\n                flex: 1;\n                display: flex;\n\n                .user-ico {\n                    flex: 1;\n                    display: none !important;\n\n                    img {\n                        width: 180px !important;\n                        height: 180px;\n                        border-radius: 100%;\n                        object-fit: cover;\n                        max-width: 200px;\n                    }\n                }\n\n                .ico-details {\n                    flex: 4;\n                    padding-left: 0px;\n                    display: flex;\n                    flex-direction: column;\n\n                    p {\n                        margin-bottom: 20px !important;\n                        margin-top: 0px !important;\n                        justify-content: flex-end !important;\n                    }\n\n                    .profilepic {\n                        display: flex;\n                        align-items: center;\n                        margin-bottom: 20px;\n                        flex-wrap: wrap;\n\n                        .profinner {\n                            max-width: 500px;\n                            width: 100%;\n                            display: flex;\n                            align-items: center;\n                            flex-wrap: wrap;\n\n                            &>div {\n                                width: auto;\n                                margin-right: 20px;\n                                display: block;\n\n                                &:last-child {\n                                    span {\n                                        color: rgba(0, 0, 0, 0.54) !important;\n                                        font-weight: 400 !important;\n\n                                        .mat-icon {\n                                            color: rgba(0, 0, 0, 0.54) !important;\n                                            font-size: 18px;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n\n                        .u-ico {\n                            margin-right: 15px;\n                        }\n\n                        .qrcode {\n                            flex: 1;\n                            display: flex;\n                            justify-content: flex-end;\n                            align-items: flex-end;\n\n                            span {\n                                font-weight: 400 !important;\n                                color: #212427;\n                            }\n                        }\n\n                        p {\n                            margin: 0px !important;\n                        }\n\n                        &>div {\n                            &:last-child {\n                                margin-right: 0px;\n                            }\n                        }\n\n                        img {\n                            border-radius: 50%;\n                            cursor: pointer;\n                        }\n                    }\n\n                    .like {\n                        max-width: 100%;\n                        margin-bottom: 0px;\n                        display: flex;\n\n                        ul {\n                            max-width: 500px;\n                            width: 100%;\n                            display: flex;\n\n                            margin-left: -17px;\n\n                            li {\n                                height: 100%;\n                                justify-content: flex-start;\n\n                                i {\n                                    font-size: 25px;\n                                    color: gray;\n                                    text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n                                    margin-bottom: 5px;\n                                }\n\n                                span {\n                                    font-size: 10px;\n                                    font-family: \"Raleway\";\n                                    font-weight: 600;\n                                    text-align: center;\n                                    color: #212427 !important;\n                                    padding: 0px !important;\n                                    min-height: 30px;\n                                    margin-left: 0px;\n                                }\n\n                                // &:last-child{\n                                //   display: none;\n                                // }\n                                // &:nth-last-child(2){\n                                //   display: none;\n                                // }\n                            }\n                        }\n\n                        div {\n                            flex: 1;\n                            text-align: right;\n                        }\n                    }\n                }\n            }\n        }\n\n        .viewflow-step {\n            width: calc(100% - 40px);\n            display: flex;\n            padding: 20px 10px 20px;\n            border: 1px solid #ddd;\n            box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n            position: relative;\n            border-radius: 10px;\n            flex-wrap: wrap;\n            background: #fff;\n            margin: 10px 20px 10px 20px;\n\n            // Force single-column (mobile-style) layout for the flow content\n            .des-item {\n                border-radius: 0px;\n                border-right: none;\n                max-width: 100%;\n                flex-basis: 100%;\n                padding-right: 0;\n                margin-right: 0;\n                display: flex;\n                flex-direction: column;\n                position: relative;\n                z-index: 2;\n\n                .des {\n                    box-shadow: none;\n                    border: 0px;\n                    padding: 0px 0px;\n                    flex: 1;\n                    border: 1px solid #ddd;\n                    border: 0px !important;\n                    margin-bottom: 0px;\n                    border-radius: 0px;\n                    padding: 0px 0px;\n                    display: flex;\n                    flex-direction: column;\n                    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n                    box-shadow: none !important;\n\n                    &>div {\n                        flex: none;\n                        color: #212427;\n                        display: flex;\n                        flex-wrap: wrap;\n                    }\n\n                    p {\n                        max-height: 287px;\n                        padding-right: 10px;\n                    }\n\n                    .s-num {\n                        font-size: 16px;\n                        width: 30px;\n                        height: 30px;\n                        color: #fff;\n                        border: 0px solid #f3f3f3;\n                        border-radius: 50%;\n                        display: flex;\n                        flex-direction: column;\n                        align-items: center;\n                        justify-content: space-around;\n                        // box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n                        font-family: \"Raleway\";\n                        font-weight: 600;\n                        margin-top: 0px;\n                        margin-bottom: 20px;\n                        position: relative;\n                        z-index: 2;\n\n                        &:before {\n                            content: \"\";\n                            width: 100%;\n                            height: 100%;\n                            border-radius: 50%;\n                            left: 0px;\n                            top: 0px;\n                            position: absolute;\n                            background: lightgray;\n                            // border:1px solid #70bfe2;\n                            z-index: -1;\n                        }\n                    }\n                }\n\n                .btm-btn {\n                    display: flex;\n                    align-items: center;\n\n                    &>div {\n                        flex: 1;\n\n                        &:first-child {\n                            justify-content: flex-start;\n                        }\n\n                        &:last-child {\n                            justify-content: right;\n                            text-align: end;\n                        }\n                    }\n\n                    .lock {\n                        display: flex;\n                        align-items: center;\n                        font-family: \"Raleway\";\n\n                        &>span {\n                            display: flex;\n                            align-items: center;\n                        }\n                    }\n                }\n            }\n\n            .step-sec {\n                box-shadow: none;\n                border: 0px;\n                padding: 0px 0px 0px 0px;\n                margin-left: 10px;\n                width: 50%;\n                display: flex;\n                flex-direction: column;\n                flex: 1;\n                border-radius: 40px;\n\n                .progressbar {\n                    border: 2px solid lightgray;\n                    margin-bottom: 20px;\n                    background: #fff;\n                    border-radius: 10px;\n                    padding: 5px;\n\n                    // box-shadow:0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n                    .w3-round {\n                        height: 7px;\n                        background: #5ea1d8;\n                        background: lightgrey;\n                    }\n                }\n\n                .img-wrap {\n                    flex: 1;\n                    display: flex;\n                    align-items: center;\n                    // max-height: 382px;\n                    position: relative;\n                    overflow: hidden;\n\n                    img {\n                        // width:auto !important;\n                        max-width: 100% !important;\n                        height: 100%;\n                        object-fit: cover;\n                        //max-height: 436px !important;\n                        margin: 0px auto;\n                        width: 100% !important;\n                    }\n\n                    &+.item {\n                        width: calc(100% - 0px) !important;\n                        margin: 17px 0px !important;\n                        border: 0px !important;\n                    }\n                }\n\n                // &:before{\n                //   content:\"‹\";\n\n                // background: #fafafa !important;\n                //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n                //     width: 35px;\n                //     height: 35px;\n                //     border-radius: 50%;\n                //     display:flex;\n                //     align-items: center;\n                //     justify-content: center;\n                //     outline:none;\n                //   position:absolute;\n                // left:-49px;\n                // top: calc(50% - 20px);\n                // font-size:35px;\n\n                // }\n                // &:after{\n                //   content:\"›\";\n\n                // background: #fafafa !important;\n                //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n                //     width: 35px;\n                //     height: 35px;\n                //     border-radius: 50%;\n                //     display:flex;\n                //     align-items: center;\n                //     justify-content: center;\n                //     outline:none;\n                //   position:absolute;\n                // right:-49px;\n                // top: calc(50% - 20px);\n                // font-size:35px;\n\n                // }\n            }\n        }\n    }\n\n    .clickarrow {\n        width: 100%;\n        display: block;\n        position: absolute;\n        margin-top: 0px;\n        width: 100%;\n        height: 35px;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        z-index: 1;\n        position: fixed;\n        position: absolute;\n        max-width: 1000px;\n\n        button.owl-prev {\n            position: absolute;\n            background: #fafafa !important;\n            background: transparent !important;\n            // background: rgba(250, 250, 250, 0.7) !important;\n            box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n                0 1px 18px 0 rgb(0 0 0 / 12%);\n            width: 35px;\n            height: 35px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            outline: none;\n            left: 0px;\n\n            span {\n                font-size: 57px;\n                line-height: 0px;\n                display: flex;\n                align-items: center;\n                margin-top: -15px;\n                font-weight: 400 !important;\n                color: #5ea1d8;\n            }\n        }\n\n        button.owl-next {\n            position: absolute;\n            background: #fafafa !important;\n            background: rgba(250, 250, 250, 0.7) !important;\n            box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n                0 1px 18px 0 rgb(0 0 0 / 12%);\n            width: 35px;\n            height: 35px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            outline: none;\n            right: 0px;\n\n            span {\n                font-size: 57px;\n                line-height: 0px;\n                display: flex;\n                align-items: center;\n                margin-top: -15px;\n                font-weight: 400 !important;\n                color: #5ea1d8;\n            }\n        }\n    }\n\n    // .flowbycat {\n    //   height: 100%;\n    //   display: table;\n    //   text-align: center;\n    // }\n    // header {\n    //   width: 100%;\n    //   height: 100px;\n    //   background: #fff;\n    //   border-bottom: 2px solid #5ea1d8;\n    // }\n\n    .partOfBundle {\n        padding: 0px 20px 20px;\n        background: #fff;\n        background: transparent;\n        // border: 1px solid #ddd;\n        // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n        margin: 0px 20px 0px 0px;\n        border-radius: 10px;\n        overflow-x: scroll;\n\n        h2 {\n            // position: absolute;\n            margin-top: 0px;\n            margin-bottom: 0px !important;\n        }\n\n        .row {\n            flex-wrap: nowrap !important;\n            width: fit-content;\n            margin-top: 10px !important;\n        }\n\n        .item {\n            background: #fff;\n            margin-left: 0px;\n            width: 170px !important;\n            padding: 10px;\n            margin-right: 10px;\n            position: relative;\n\n            &>div:first-child {\n                img {\n                    height: 150px !important;\n                }\n            }\n\n            &>div:last-child {\n                p {\n                    height: 25px !important;\n                }\n            }\n        }\n    }\n\n    .qr-ico {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        height: 100%;\n        position: absolute;\n        right: 20px;\n\n        i {\n            flex: 1;\n            font-size: 25px;\n            color: grey;\n        }\n\n        p {\n            font-weight: 600;\n        }\n    }\n\n    // .social-ico {\n    //   max-width: 275px;\n    //   margin-top: 20px;\n    // }\n    // .social-ico ul li .fa {\n    //   font-size: 27px;\n    //   color: gray;\n    //   text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n    //   margin-bottom: 5px;\n    //   font-size: 30px;\n    // }\n    // .social-ico ul li .fa.fa-facebook-square {\n    //   color: #4266b2;\n    // }\n\n    // .social-ico ul li .fa.fa-twitter-square {\n    //   color: #55aded;\n    // }\n    // .social-ico ul li .fa.fa-linkedin-square {\n    //   color: #007ab9;\n    // }\n    // .social-ico ul li .fa.fa-xing-square {\n    //   color: #f96678;\n    // }\n    .material-icons,\n    .align-items-center {\n        color: #212427 !important;\n        font-weight: normal !important;\n        cursor: pointer;\n        display: flex;\n    }\n\n    img {\n        width: 100%;\n    }\n\n    p {\n        font-family: \"Raleway\";\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    button {\n        padding: 3px 10px;\n        // background: #5ea1d8;\n        border: 0px;\n        // color: #fff;\n        font-size: 15px;\n        border-radius: 5px;\n    }\n\n    button.active {\n        background: #5ea1d8;\n        color: white;\n    }\n\n\n    h2 {\n        font-family: \"Raleway\";\n        margin-bottom: 20px;\n\n        a {\n            color: #212427 !important;\n        }\n    }\n\n    h3 {\n        font-family: \"Raleway\";\n        margin-bottom: 20px;\n        font-size: 16px;\n        font-weight: bold;\n    }\n\n    ul {\n        display: flex;\n        list-style: none;\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n    }\n\n    li {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n\n        span {\n            // margin-left: 0px;\n        }\n    }\n\n    .like {\n        .qrcode {\n            flex: 1;\n            display: flex;\n            align-items: flex-end;\n            justify-content: flex-end;\n        }\n    }\n\n    /*description wrapper starts here*/\n    .description-wrapper {\n\n        // display: flex;\n        // background: #fff;\n        // margin: 10px 20px 10px 20px;\n        .des-item {\n\n            // flex-basis: calc(50% - 20px);\n            // // max-width: 3;\n            // margin-right: 10px;\n            // display: flex;\n            // flex-direction: column;\n            .des {\n                /*max-height:200px;*/\n                // flex: 1;\n                // border: 1px solid #ddd;\n                // margin-bottom: 0px;\n\n                // border-radius: 0px;\n                // padding: 40px 20px;\n                // display: flex;\n                // flex-direction: column;\n                // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n                p {\n                    max-height: 100px;\n                    overflow-y: auto;\n                }\n            }\n        }\n    }\n\n    // .des-item .des > div {\n    //   flex: 1;\n    //   display: flex;\n    //   align-items: flex-start;\n    //   margin-top: 20px;\n    // }\n    .des-item .des>div span {\n        flex: 1;\n        font-family: \"RALEWAY\";\n    }\n\n    .des-item .des>div span.material-icons.ng-star-inserted {\n        max-width: 30px;\n    }\n\n    .des-item .des>div span:first-child {\n        align-items: flex-start;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n    }\n\n    .des-item .des>div span:last-child {\n        text-align: flex-end;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n    }\n\n    .des-item .des>div span i {\n        margin-right: 5px;\n    }\n\n    .des-item .item {\n        flex: 1;\n        border: 1px solid #ddd;\n        border-radius: 40px;\n        padding: 40px 20px;\n        box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n        margin-top: 20px;\n    }\n\n    .des-item .item .list {\n        display: flex;\n        /* padding: 20px 0px; */\n        max-height: 150px;\n        overflow-y: auto;\n        align-items: flex-start;\n    }\n\n    .des-item .item .list ul {\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        margin: 0px 0px 20px;\n        padding: 5px;\n    }\n\n    .des-item .item .list ul li {\n        font-family: \"Raleway\";\n        font-size: 14px;\n        line-height: 28px;\n        word-break: break-all;\n        position: relative;\n\n        padding-left: 17px;\n\n        &:before {\n            content: \"\";\n            width: 8px;\n            height: 8px;\n            background: grey;\n            position: absolute;\n            left: 0px;\n            top: 10px;\n            border-radius: 50%;\n            box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n        }\n\n        &:first-child {\n            padding-left: 0px;\n\n            &:before {\n                display: none;\n            }\n        }\n    }\n\n    .des-item .item .list ul li:first-child {\n        font-weight: 600;\n    }\n\n    // .step-sec {\n    //   flex: 1;\n    //   padding: 40px;\n    //   border: 1px solid #ddd;\n    //   border-radius: 40px;\n    // }\n\n    video {\n        // width:auto !important;\n        max-width: 100% !important;\n        //max-height: 300px !important;\n        margin: 0px auto;\n        width: 100% !important;\n    }\n\n    &:empty {\n        display: none !important;\n    }\n}\n\n.step-sec .img-wrap:after {\n    content: \"›\";\n\n    background: #fafafa !important;\n    box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    position: absolute;\n    right: -49px;\n    top: calc(50% - 20px);\n    font-size: 35px;\n    margin-top: -8px;\n    display: none;\n}\n\n.step-sec .img-wrap:before {\n    content: \"‹\";\n\n    background: #fafafa !important;\n    box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    position: absolute;\n    left: -49px;\n    top: calc(50% - 20px);\n    font-size: 35px;\n    margin-top: -8px;\n    display: none;\n}\n\n.des-item .des p::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n}\n\n.des-item .des p::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.des-item .des p::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n}\n\n.des-item .item .list::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n}\n\n.des-item .item .list::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.des-item .item .list::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n}\n\n.step-sec {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n\n// .progressbar {\n//   flex: 1;\n//   display: table;\n//   align-items: center;\n//   height:30px;\n//   background:#fff;\n// }\n.progressbar ul {\n    display: flex;\n    flex-basis: 100%;\n}\n\n.progressbar ul li {\n    flex: 1;\n    display: flex;\n    align-items: center;\n}\n\n.progressbar ul li a {\n    width: 20px;\n    height: 20px;\n    background: #5ea1d8;\n    border-radius: 50%;\n    color: #fff;\n    text-decoration: none;\n    text-align: center;\n    font-size: 12px;\n    font-family: \"RALEWAY\";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.progressbar ul li a:before {\n    counter-increment: my-sec-counter;\n    content: \"\" counter(my-sec-counter) \"\";\n}\n\nimg {\n    max-width: 100%;\n}\n\n@media only screen and (max-width: 1025px) and (min-width: 320px) {\n    .view-flow {\n\n        // background:#fff;\n        h2 {\n            font-size: 22px !important;\n            // word-break: break-all;\n        }\n    }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n    .view-flow {\n        .container1 {\n            display: flex;\n            flex-direction: column;\n            padding: 0px 15px 20px;\n\n            .user-sec {\n                flex-direction: column;\n\n                // margin:0px;\n                // padding: 0rem 0px 2rem;\n                .user-details {\n                    flex-direction: column;\n                    order: 2;\n\n                    .user-ico {\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                    }\n\n                    .ico-details {\n                        padding: 0px;\n\n                        .profilepic {\n                            &>div {\n                                p {\n                                    font-size: 14px;\n                                }\n                            }\n                        }\n\n                        .like {\n                            display: flex;\n                            // flex-direction: column;\n                            margin-left: 0px;\n\n                            ul {\n                                margin-left: 0px;\n\n                                // max-width: 100%;\n                                li {\n                                    i {\n                                        font-size: 20px;\n                                    }\n                                }\n                            }\n\n                            .qrcode {\n                                span {\n                                    margin-right: 0px !important;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .qr-code {\n                    padding: 10px 0px;\n                }\n            }\n        }\n\n        .description-wrapper {\n            flex-direction: column;\n            margin: 0px;\n            margin-bottom: 20px;\n\n            .des-item {\n                margin-right: 0px;\n                margin-bottom: 20px;\n                flex-basis: 100%;\n                max-width: unset;\n                border-right: 0px;\n                padding-right: 0px;\n\n                .des {\n                    &>div {\n                        span {\n                            &:first-child {\n                                justify-content: flex-start;\n                            }\n                        }\n                    }\n\n                    .timer-wrap {\n                        display: flex;\n                        flex-direction: column;\n                        flex: none;\n                        color: #212427;\n\n                        >* {\n                            margin-right: 10px;\n                        }\n                    }\n                }\n            }\n\n            .step-sec {\n                .img-wrap {\n                    img {\n                        //max-height: 300px !important;\n                    }\n                }\n            }\n        }\n\n        .viewflow-step {\n            width: 100%;\n            margin: 0px auto 20px;\n\n            .des-item {\n                flex-basis: 100%;\n                max-width: unset;\n                border-bottom: 2px solid lightgrey;\n                padding-bottom: 20px;\n\n                .des {\n                    padding-bottom: 20px;\n                    // border-bottom:1px solid lightgray;\n                    border-radius: 0px;\n                }\n            }\n\n            .step-sec {\n                padding: 0px;\n                margin-left: 0px;\n                width: 100%;\n            }\n\n            .clickarrow {\n                button {\n                    width: 25px;\n                    height: 25px;\n\n                    &.owl-prev {\n                        // left: -20px;\n                        // background:transparent !important;\n                        // box-shadow: none !important;\n                    }\n\n                    &.owl-next {\n                        // right: -20px;\n                        // background:transparent !important;\n                        // box-shadow: none !important;\n                    }\n                }\n            }\n        }\n\n        .ico-details .profilepic {\n            flex-wrap: nowrap;\n        }\n    }\n\n    .view-flow .container1 .user-sec .user-details .ico-details {\n        .profilepic {\n            .profinner {\n                width: 100% !important;\n                flex-basis: 100% !important;\n                max-width: 100% !important;\n\n                &+.qrcode {\n                    width: 100%;\n                    justify-content: flex-end;\n                }\n            }\n\n            &+.like-list {\n                flex-direction: column;\n            }\n        }\n    }\n\n    .view-flow .container1 .viewflow-step .step-sec {\n        width: 100%;\n        margin: 0px;\n    }\n\n    .supportingdoc {\n        position: relative !important;\n        padding: 10px 10px 10px 0px !important;\n    }\n}\n\n/*table struture starts here*/\n.table-wrap {\n    max-height: 260px;\n    overflow-y: auto;\n    padding-right: 7px;\n\n    &::-webkit-scrollbar {\n        width: 4px;\n        height: 100px;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #5ea1d8;\n        outline: 1px solid #5ea1d8;\n    }\n}\n\ntable {\n    padding-right: 20px;\n    width: 100%;\n\n    tr {\n        display: flex;\n        width: 100%;\n        flex-flow: row wrap;\n        justify-content: space-between;\n\n        th {\n            font-family: \"Raleway\";\n            font-weight: 600 !important;\n            font-size: 16px !important;\n            width: 48%;\n            word-break: break-all;\n            margin-bottom: 15px;\n            line-height: 25px;\n        }\n\n        td {\n            width: 100%;\n            word-break: break-all;\n            margin-bottom: 15px;\n            font-family: \"Raleway\";\n            font-weight: 400;\n            line-height: 25px;\n            font-size: 13px;\n            position: relative;\n            padding-left: 15px;\n            display: flex;\n\n            &>span {\n                width: 48%;\n                overflow-wrap: break-word;\n\n                &:first-child {\n                    margin-right: 4%;\n                }\n            }\n\n            &:before {\n                content: \"\";\n                width: 8px;\n                height: 8px;\n                background: grey;\n                position: absolute;\n                left: 0px;\n                top: 8px;\n                border-radius: 50%;\n                box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n            }\n\n            // &:nth-child(even){\n            //   &:before{\n            //     display: none;\n            //   }\n            // }\n        }\n    }\n}\n\n// .cdk-overlay-pane .mat-menu-panel{\n//   left:-250px !important;\n//   top:-19px !important;\n\n// }\n\n.like-list {\n    .fashion-btn {\n        display: block;\n    }\n}\n\n.qr-code {\n\n    .lock,\n    .fashion-btn {\n        display: none;\n    }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 461px) {\n    .view-flow {\n        .container1 {\n            .user-sec {\n                .user-details {\n                    flex-direction: row;\n\n                    // margin-bottom:30px;\n                    // padding-left:15px;\n                    .ico-details {\n                        padding-left: 15px;\n                        max-width: 100%;\n\n                        .like {\n                            ul {\n                                margin-left: -15px;\n                            }\n\n                            .qrcode {\n                                span {\n                                    margin-right: 15px !important;\n                                }\n                            }\n                        }\n\n                        .profilepic {\n                            &>div {\n                                p {\n                                    font-size: 14px !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            .description-wrapper {\n                width: auto;\n                // max-width:80%;\n                // max-width:calc(100% - 50px);\n                margin: 10px 20px;\n\n                .step-sec {\n                    .img-wrap {\n                        max-height: unset;\n                    }\n                }\n            }\n\n            .viewflow-step {\n                .des-item {\n                    .des {\n                        padding-bottom: 20px;\n                        // border-bottom:1px solid lightgray;\n                        border-radius: 0px;\n                    }\n                }\n\n                .clickarrow button {\n                    &.owl-next {\n                        right: -8px;\n                    }\n\n                    &.owl-prev {\n                        left: -8px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n    .view-flow {\n        .viewflow-step {\n            .clickarrow {\n                button {\n                    width: 35px;\n                    height: 35px;\n\n                    &.owl-prev {\n                        left: -45px;\n                    }\n\n                    &.owl-next {\n                        right: -45px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 460px) and (min-width: 320px) {\n    .view-flow .container1 .user-sec .user-details .ico-details .profilepic>div p {\n        font-size: 11px !important;\n    }\n\n    .ico-details .profilepic>div:last-child {\n        span {\n            font-size: 11px;\n        }\n    }\n\n    .view-flow .viewflow-step .clickarrow {\n        button {\n            width: 35px;\n            height: 35px;\n\n            &.owl-prev {\n                left: 0px;\n                // background:transparent !important;\n                // box-shadow: none !important;\n            }\n\n            &.owl-next {\n                right: 0px;\n                // background:transparent !important;\n                // box-shadow: none !important;\n            }\n        }\n    }\n\n    .view-flow .viewflow-step {\n        width: auto;\n        margin: 10px 0px;\n    }\n\n    .qr-code {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        position: relative;\n\n        .priceIcon-wp {\n            position: relative !important;\n            top: -2px;\n        }\n\n        .lock {\n            >span {\n                display: flex;\n                align-items: center;\n            }\n        }\n\n        .qr-ico {\n            // width: 24px;\n            // background: gray;\n            // display: block;\n            // height: 35px;\n        }\n\n        .lock,\n        .fashion-btn {\n            display: block;\n        }\n    }\n\n    .profilepic {\n        .lock {\n            display: none !important;\n        }\n    }\n\n    .like-list {\n        .fashion-btn {\n            display: none !important;\n        }\n    }\n\n    .view-flow h2 span {\n        font-size: 20px !important;\n        word-break: break-word;\n    }\n\n    .view-flow .container1 .user-sec {\n        padding: 10px;\n        margin: 0px;\n    }\n\n    .ico-details .profilepic .profinner>div {\n        margin-right: 5px;\n    }\n\n    .ico-details .profilepic>div {\n        margin-right: 0px;\n    }\n\n    .like li:last-child {\n        // display: none !important;\n    }\n\n    .viewflow-step .des-item .des p {\n        max-height: 133px;\n    }\n\n    .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {\n        font-size: 9px;\n    }\n\n    .partOfBundle {\n        padding: 0px;\n        margin-right: 5px;\n    }\n}\n\nbutton.common {\n    padding: 3px 6px !important;\n    background: #5ea1d8 !important;\n    // background: pink !important;\n    border: 0px !important;\n    color: #fff !important;\n    font-size: 13px !important;\n    border-radius: 5px !important;\n}\n\n@media (max-width: 500px) {\n    .ico-details .profilepic .qrcode {\n        justify-content: center;\n    }\n}\n\n.example-list {\n    max-width: 100%;\n    // border: solid 1px #ccc;\n    // min-height: 246px;\n    height: auto;\n    display: flex;\n    background: white;\n    flex-direction: column;\n    // border-radius: 4px;\n    overflow-y: auto;\n\n    .example-box {\n        display: flex;\n        padding: 15px 10px;\n        border-bottom: 1px solid lightgrey;\n        background: white !important;\n        flex: 1;\n        padding: 15px 10px;\n        border-bottom: solid 1px lightgray;\n        color: rgba(0, 0, 0, 0.87);\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        box-sizing: border-box;\n        cursor: move;\n        background: white;\n        font-size: 14px;\n\n        .item-name {\n            text-align: left;\n            width: 70%;\n        }\n\n        .item-value {\n            text-align: left;\n            width: 30%;\n        }\n\n        .item-name,\n        .item-delete,\n        .item-reorder,\n        .item-value {\n            text-align: left;\n            padding: 5px;\n            font-size: 14px;\n            font-weight: 400 !important;\n            overflow-wrap: break-word;\n        }\n\n        .item-delete,\n        .item-reorder {\n            float: right;\n            cursor: pointer;\n            font-size: 20px;\n            width: 10%;\n        }\n\n        &:last-child {\n            border-bottom: 0px;\n        }\n\n        img {\n            border-bottom: 0px;\n            width: 40px !important;\n            max-width: 40px;\n            height: 40px !important;\n            object-fit: cover;\n        }\n\n        &>* {\n            flex: 1;\n            color: #212427 !important;\n            font-weight: normal !important;\n        }\n\n        a {\n            color: #007bff !important;\n        }\n    }\n\n    &::-webkit-scrollbar {\n        width: 4px;\n        height: 100px;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #5ea1d8;\n        outline: 1px solid #5ea1d8;\n    }\n}\n\n.example-box {\n    padding: 15px 10px;\n    border-bottom: solid 1px lightgray;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    font-size: 14px;\n\n    &>div {\n        width: 50%;\n        display: flex !important;\n\n        &:first-child {\n            width: 80%;\n        }\n\n        &:last-child {\n            width: 17%;\n        }\n\n        &>span {\n            // width:48%;\n            text-align: left;\n            word-break: keep-all;\n            display: flex;\n            align-items: center;\n\n            &:first-child {\n                flex: 1;\n                width: 50%;\n                color: rgba(0, 0, 0, 0.54) !important;\n                font-weight: 400 !important;\n            }\n\n            &:last-child {\n                width: 50%;\n                text-align: center;\n                display: flex;\n                align-items: center;\n                justify-content: end;\n                white-space: nowrap;\n                color: rgba(0, 0, 0, 0.54) !important;\n                font-weight: 400 !important;\n            }\n        }\n    }\n}\n\n.itemremove {\n    span {\n        &:first-child {\n            width: 90% !important;\n        }\n\n        &:nth-child(2) {\n            // display:none;\n        }\n    }\n}\n\n.img-div-left {\n    position: fixed;\n    z-index: 9999999 !important;\n    height: 100px;\n    width: 100px;\n    overflow: visible;\n    margin: auto;\n    top: 5% !important;\n    left: 0;\n    bottom: 0;\n    right: 0;\n\n    img {\n        width: 100%;\n        height: 100%;\n        position: absolute !important;\n        top: 0% !important;\n    }\n}\n\n/*new design starts here*/\n.viewbundle {\n    .step-sec {\n        &+.row {\n            margin-top: 40px !important;\n            display: flex;\n            justify-content: flex-start;\n            width: 100%;\n\n            &>div {\n                width: 25% !important;\n\n                .item {\n                    box-shadow: none !important;\n\n                    img {\n                        width: calc(100% - 20px) !important;\n                        object-fit: cover;\n                        margin: 10px !important;\n                    }\n\n                    p {\n                        padding-left: 5px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        height: 33px !important;\n                        white-space: normal;\n                        word-break: break-word;\n                    }\n\n                    .with-icon {\n                        display: flex;\n\n                        img {\n                            width: 30px !important;\n                            height: 30px !important;\n                            border-radius: 20px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.mat-accent {\n    display: flex;\n    justify-content: flex-end;\n}\n\n@media (max-width: 460px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 50% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 33% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// .viewbundle {\n//   .img-wrap {\n//     & + .item {\n//       width: calc(100% - 0px) !important;\n//       margin: 17px 0px !important;\n//       border: 0px !important;\n//     }\n//   }\n// }\n.example-list .example-box {\n    .item-name {\n        padding-left: 10px !important;\n        border-right: 1px solid #ddd;\n    }\n\n    .item-value {\n        padding-left: 10px !important;\n    }\n}\n\n.textcolor {\n    color: #5ea1d8;\n}\n\n// .item {\n//   // height: 220px !important;\n//   // background-color: lightgray;\n//   border: solid 1px;\n//   margin: 17px;\n//   width: 170px;\n//   border: solid 0.5px lightgrey;\n// }\n\n.item .img {\n    height: 150px !important;\n    background-color: lightgray;\n}\n\np {\n    margin: 0px;\n}\n\n.zoom {\n    cursor: pointer;\n    width: 100%;\n    height: 70%;\n    transition: transform 0.1s;\n    /* Animation */\n}\n\n.zoom:hover {\n    border-radius: 5px;\n    // -ms-transform: scale(1.2); /* IE 9 */\n    // -webkit-transform: scale(1.5); /* Safari 3-8 */\n    transform: scale(1.1);\n    /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n    font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n    font-size: 55px !important;\n}\n\nbutton span {\n    font-size: 55px;\n}\n\n.owl-nav {\n    display: none;\n}\n\n.with-icon {\n    display: flex;\n    align-items: center;\n}\n\n.mat-badge-content {\n    background: #5ea1d8;\n}\n\n.div1 {\n    height: 50px;\n    //border: 1px solid blue;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    background-color: white;\n    overflow: hidden;\n    z-index: 100;\n}\n\n.user-pro {\n    .row {\n        justify-content: left;\n    }\n\n    .ng-star-inserted {\n        width: 15.6%;\n        margin-right: 1%;\n        // &:nth-child(6n+6){\n        //   .item{\n        //     margin-right:0px;\n        //   }\n\n        //       }\n    }\n\n    .item {\n        width: 100% !important;\n        overflow: hidden;\n        background: #fff;\n        border: 1px solid #dddddd;\n        margin: 0px;\n        margin-right: 20px;\n        margin-bottom: 20px;\n\n        &>div {\n            margin: 5px;\n        }\n\n        p {\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n\n            &:last-of-type {\n                height: auto !important;\n                // font-size: 12px !important;\n            }\n        }\n\n        .with-icon {\n            width: 100%;\n            font-family: \"Raleway\";\n            display: flex;\n            align-items: center;\n\n            >div {\n                width: 30px;\n                height: 30px;\n                border-radius: 50%;\n                overflow: hidden;\n                display: flex;\n                align-items: center;\n                margin-right: 5px;\n            }\n\n            img {\n                object-fit: cover;\n                height: 40px !important;\n                border: 0px;\n            }\n        }\n\n        .zoom {\n            margin: 5px;\n            width: calc(100% - 10px);\n            background-color: transparent;\n        }\n\n        img {\n            height: 150px;\n            object-fit: cover;\n            width: 100%;\n            border: 1px solid #dddddd;\n        }\n    }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 993px) {\n    .user-pro {\n        .row {\n            justify-content: left;\n            text-align: start;\n        }\n\n        .ng-star-inserted {\n            max-width: 18% !important;\n            width: 18% !important;\n            margin: 1% !important;\n            // &:nth-child(5n + 5){\n            //   margin-right:0px;\n            // }\n        }\n\n        .item {\n            max-width: 100% !important;\n            width: 100% !important;\n            overflow: hidden;\n            background: #fff;\n            border: 1px solid #dddddd;\n            margin: 0px;\n            margin-right: 0px;\n            margin-bottom: 20px;\n\n            &>div {\n                margin: 5px;\n            }\n\n            p {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                height: 33px !important;\n                white-space: normal;\n                word-break: break-word;\n            }\n\n            .with-icon {\n                max-width: 100% !important;\n                width: 100% !important;\n                font-family: \"Raleway\";\n                display: flex;\n                align-items: center;\n                max-width: 100% !important;\n\n                >div {\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 50%;\n                    overflow: hidden;\n                    display: flex;\n                    align-items: center;\n                    margin-right: 5px;\n                }\n\n                img {\n                    object-fit: cover;\n                    height: 40px !important;\n                    border: 0px;\n                }\n            }\n\n            .zoom {\n                margin: 5px;\n                width: calc(100% - 10px);\n                background-color: transparent;\n            }\n\n            img {\n                height: 150px;\n                object-fit: cover;\n                width: 100%;\n                border: 1px solid #dddddd;\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n    .user-pro {\n        .row {\n            justify-content: left;\n            text-align: start;\n        }\n\n        .ng-star-inserted {\n            max-width: 23% !important;\n            width: 23% !important;\n            margin: 1% !important;\n            // &:nth-child(4n + 4){\n            //   margin-right:0px;\n            // }\n        }\n\n        .item {\n            max-width: 100% !important;\n            width: 100% !important;\n            overflow: hidden;\n            background: #fff;\n            border: 1px solid #dddddd;\n            margin: 0px;\n            margin-right: 0px;\n            margin-bottom: 20px;\n\n            &>div {\n                margin: 5px;\n            }\n\n            p {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                height: 33px !important;\n                white-space: normal;\n                word-break: break-word;\n            }\n\n            .with-icon {\n                max-width: 100% !important;\n                width: 100% !important;\n                font-family: \"Raleway\";\n                display: flex;\n                align-items: center;\n\n                >div {\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 50%;\n                    overflow: hidden;\n                    display: flex;\n                    align-items: center;\n                    margin-right: 5px;\n                }\n\n                img {\n                    object-fit: cover;\n                    height: 40px !important;\n                    border: 0px;\n                }\n            }\n\n            .zoom {\n                margin: 5px;\n                width: calc(100% - 10px);\n                background-color: transparent;\n            }\n\n            img {\n                height: 150px;\n                object-fit: cover;\n                width: 100%;\n                border: 1px solid #dddddd;\n            }\n        }\n    }\n\n    h3 {\n        padding-left: 12px;\n    }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n    .user-pro {\n        .row {\n            justify-content: left;\n            text-align: start;\n        }\n\n        .ng-star-inserted {\n            max-width: 31.3% !important;\n            width: 31.3% !important;\n            margin: 1%;\n            // &:nth-child(3n+3){\n            //   margin-right:0%;\n            //   // .item{\n            //   //   margin-right:0px;\n            //   // }\n\n            //       }\n        }\n\n        .item {\n            max-width: 100% !important;\n            width: 100% !important;\n            overflow: hidden;\n            background: #fff;\n            border: 1px solid #dddddd;\n            margin: 0px;\n            margin-right: 0px;\n            margin-bottom: 0px;\n\n            &>div {\n                margin: 5px;\n            }\n\n            p {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                height: 33px !important;\n                white-space: normal;\n                word-break: break-word;\n            }\n\n            .with-icon {\n                width: 100%;\n                font-family: \"Raleway\";\n                display: flex;\n                align-items: center;\n\n                >div {\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 50%;\n                    overflow: hidden;\n                    display: flex;\n                    align-items: center;\n                    margin-right: 5px;\n                }\n\n                img {\n                    object-fit: cover;\n                    height: 40px !important;\n                    border: 0px;\n                }\n\n                &.ng-star-inserted {\n                    max-width: 100% !important;\n                    width: 100% !important;\n                }\n            }\n\n            .zoom {\n                margin: 5px;\n                width: calc(100% - 10px);\n                background-color: transparent;\n            }\n\n            img {\n                height: 150px;\n                object-fit: cover;\n                width: 100%;\n                border: 1px solid #dddddd;\n            }\n        }\n    }\n\n    h3 {\n        padding-left: 12px;\n    }\n}\n\n@media screen and (max-width: 460px) {\n    .user-pro {\n        .row {\n            justify-content: left;\n            text-align: start;\n        }\n\n        .ng-star-inserted {\n            max-width: 48% !important;\n            width: 48% !important;\n            margin: 1%;\n            // &:nth-child(2n+2){\n            //   margin-right:0px;\n            //   // .item{\n            //   //   margin-right:0px;\n            //   // }\n\n            //       }\n        }\n\n        .item {\n            max-width: 100% !important;\n            width: 100% !important;\n            overflow: hidden;\n            background: #fff;\n            border: 1px solid #dddddd;\n            margin: 0px;\n            margin-right: 0px;\n            margin-bottom: 0px;\n\n            &>div {\n                margin: 5px;\n            }\n\n            p {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                height: 33px !important;\n                white-space: normal;\n                word-break: break-word;\n            }\n\n            .with-icon {\n                width: 100%;\n                font-family: \"Raleway\";\n                display: flex;\n                align-items: center;\n\n                >div {\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 50%;\n                    overflow: hidden;\n                    display: flex;\n                    align-items: center;\n                    margin-right: 5px;\n                }\n\n                img {\n                    object-fit: cover;\n                    height: 40px !important;\n                    border: 0px;\n                }\n\n                &.ng-star-inserted {\n                    max-width: 100% !important;\n                    width: 100% !important;\n                }\n            }\n\n            .zoom {\n                margin: 5px;\n                width: calc(100% - 10px);\n                background-color: transparent;\n            }\n\n            img {\n                height: 150px;\n                object-fit: cover;\n                width: 100%;\n                border: 1px solid #dddddd;\n            }\n        }\n    }\n\n    h3 {\n        padding-left: 7px;\n    }\n}\n\n// .img-div-left{\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n\n.scroll .item .uni-wrapper .bundleIcon {\n    bottom: 10px;\n    right: 10px;\n    z-index: 10;\n    width: 25px !important;\n    height: 25px !important;\n    max-width: 25px !important;\n    height: 25px !important;\n\n    img {\n        width: 100% !important;\n        height: 20px !important;\n        object-fit: contain;\n        border: none;\n    }\n}\n\n.uni-wrapper {\n\n    // display: flex;\n    // width: 100%;\n    // align-items: center;\n    P {\n        flex: 1;\n    }\n}\n\n/*new design starts here new bundle*/\n.viewbundle {\n    .step-sec {\n        &+.row {\n            margin-top: 40px !important;\n            display: flex;\n            justify-content: flex-start;\n            width: 100%;\n\n            &>div {\n                width: 25% !important;\n\n                .item {\n                    box-shadow: none !important;\n\n                    img {\n                        width: calc(100% - 20px) !important;\n                        object-fit: cover;\n                        margin: 10px !important;\n                    }\n\n                    p {\n                        padding-left: 5px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        height: 33px !important;\n                        white-space: normal;\n                        word-break: break-word;\n                    }\n\n                    .with-icon {\n                        display: flex;\n\n                        img {\n                            width: 30px !important;\n                            height: 30px !important;\n                            border-radius: 20px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 460px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 50% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 33% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.bundleIcons {\n    bottom: 10px;\n    right: 10px;\n    z-index: 10;\n    width: 25px !important;\n    height: 25px !important;\n    padding-left: 5px;\n\n    img {\n        width: 100% !important;\n        height: auto !important;\n        object-fit: contain;\n        border: none;\n    }\n}\n\n.partOfBundle {\n    .item {\n        .uni-wrapper {\n            display: flex;\n\n            p {\n                justify-content: flex-start !important;\n            }\n        }\n    }\n}\n\n.uni-wrapper {\n\n    // display: flex;\n    // width: 100%;\n    // align-items: center;\n    // height: 35px;\n    P {\n        flex: 1;\n        display: flex;\n        align-items: flex-end;\n        justify-content: flex-start;\n        margin-top: 0px !important;\n        margin-bottom: 0px !important;\n    }\n}\n\n.viewbundle {\n    .step-sec {\n        &+.row {\n            margin-top: 40px !important;\n            display: flex;\n            justify-content: flex-start;\n            width: 100%;\n\n            &>div {\n                width: 25% !important;\n\n                .item {\n                    box-shadow: none !important;\n\n                    img {\n                        width: calc(100% - 20px) !important;\n                        object-fit: cover;\n                        margin: 10px !important;\n                    }\n\n                    p {\n                        padding-left: 5px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        height: 33px !important;\n                        white-space: normal;\n                        word-break: break-word;\n                    }\n\n                    .with-icon {\n                        display: flex;\n\n                        img {\n                            width: 30px !important;\n                            height: 30px !important;\n                            border-radius: 20px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 460px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 50% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n    .viewbundle {\n        .step-sec {\n            &+.row {\n                &>div {\n                    width: 33% !important;\n\n                    .item {\n                        .with-icon {\n                            display: flex;\n                            align-items: center;\n\n                            &>div {\n                                width: 30px !important;\n                            }\n\n                            img {\n                                margin: 0px !important;\n                            }\n\n                            p {\n                                padding-left: 5px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (max-width: 1024px) {\n    .view-flow .container1 .user-sec {\n        margin: 0px !important;\n    }\n\n    .view-flow .viewflow-step {\n        width: 100% !important;\n        margin: 10px 0px !important;\n    }\n\n    .partOfBundle {\n        padding: 0px;\n        margin-right: 5px;\n    }\n}\n\n@media (max-width: 992px) {\n    .view-flow .viewflow-step .des-item {\n        padding: 0px;\n        border: 0px;\n        flex-basis: 100% !important;\n        max-width: 100% !important;\n        margin: 0px !important;\n        padding: 0px !important;\n        border: 0px !important;\n\n        .des {\n            padding: 0px;\n            padding: 0px 0px 20px !important;\n\n            p {\n                margin: 0px;\n            }\n        }\n    }\n\n    .view-flow .qr-ico {\n        position: relative;\n        right: 0px;\n    }\n}\n\n// .step-sec{\n//   width:100% !important;\n//   flex-basis: 100% !important;\n//     max-width: 100% !important;\n//     margin-left: 0px !important;\n// }\n\n.font16 {\n    font-size: 14px !important;\n    font-family: \"Raleway\";\n    color: rgba(0, 0, 0, 0.54) !important;\n    font-weight: bold;\n}\n\n.priceIcon-p .font16 {\n    font-size: 10px !important;\n    color: #fff !important;\n}\n\n.timer-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 20px;\n\n    br {\n        display: none;\n    }\n\n    h6 {\n        width: 100%;\n        display: block;\n        margin-bottom: 15px;\n    }\n\n    .icon-wrap {\n        display: flex;\n        flex-wrap: wrap;\n        width: 100%;\n\n        .textbodycolor {\n            justify-content: flex-start !important;\n            padding-left: 10px;\n        }\n    }\n}\n\n.newdesignadd {\n    display: block;\n    width: 100%;\n    color: #212427;\n    border: 1px solid lightgray;\n    border: 0px !important;\n    padding-left: 0px;\n\n    .item-name {\n        justify-content: flex-start !important;\n\n        a {\n            color: #5ea1d8;\n        }\n    }\n}\n\n.timer-wrap+h6 {\n    margin-bottom: 15px;\n}\n\n.not-draggable {\n    -webkit-user-drag: none;\n    /* Safari/Chrome */\n    -moz-user-select: none;\n    /* Firefox */\n    -ms-user-select: none;\n    /* IE10+ */\n    user-select: none;\n    /* Standard syntax */\n    cursor: default;\n    /* Optional: Change the cursor style */\n    transform: translate(0, 0) !important;\n}\n\n.divscroll {\n    width: 100% !important;\n    display: flex;\n    flex-direction: row;\n    max-height: 100px;\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    div {\n        width: 100% !important;\n    }\n}\n\n.view-flow .container1 .viewflow-step .step-sec .img-wrap {\n    flex: none !important;\n}\n\n// .qr-codeadd {\n//   .lock {\n//     display: block !important;\n//     &>span:first-child{\n//       display: none !important;\n//     }\n//   }\n// }\n\n@media (max-width: 767px) {\n    .partOfBundle {\n        padding: 0px 0px 20px 0px !important;\n        margin-right: 0px !important;\n\n        h2 {\n            margin-top: 0px !important;\n        }\n    }\n\n    .view-flow .container1 .viewflow-step {\n        margin-bottom: 10px !important;\n    }\n\n    .view-flow .partOfBundle h2 {\n        margin-top: 15px !important;\n    }\n}\n\n.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {\n    div:nth-child(4) {\n        position: relative;\n\n        span {\n            position: relative;\n        }\n    }\n}\n\n/*chatbot design*/\n.chatbot-wrapper {\n    position: fixed;\n    bottom: 0px;\n    right: 20px;\n    padding: 20px;\n    display: flex;\n    padding: 20px 0px 0px;\n    background: #fff;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n    margin: 0px 20px 0px 20px;\n    border-radius: 10px 10px 0px 0px;\n    max-width: 400px;\n    width: 100%;\n    box-sizing: border-box;\n    z-index: 1000;\n    flex-wrap: wrap;\n    // max-height: 400px;\n    min-height: 400px;\n    // height: 100%;\n    max-height: calc(100% - 120px);\n    overflow-y: hidden;\n    flex-direction: row;\n\n    &:before {\n        content: \"\";\n        width: 100%;\n        height: 31%;\n        height: 124px;\n        background: rgb(94, 161, 216) !important;\n        position: absolute;\n        top: 0px;\n        left: 0px;\n        z-index: -1;\n    }\n\n    .chatbot-msg {\n        padding: 0px 20px;\n        width: 100%;\n\n        .chatbot-msgdetails {\n            .flora-close {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                color: #fff;\n                margin-bottom: 15px;\n\n                button {}\n\n                h5 {\n                    color: #fff;\n                }\n            }\n\n            .welcome-text {\n                color: #fff;\n                margin-bottom: 15px;\n\n                h2 {\n                    color: #fff !important;\n                    font-size: 20px !important;\n                    margin-bottom: 10px !important;\n                }\n\n                p {\n                    color: #fff !important;\n                    font-weight: 400 !important;\n                    margin: 0px !important;\n                    display: -webkit-box;\n                    -webkit-line-clamp: 2;\n                    -webkit-box-orient: vertical;\n                    max-width: 100%;\n                    overflow: hidden;\n                }\n            }\n\n            .image {\n                margin-bottom: 20px;\n            }\n\n            .chabot-category {\n                display: flex;\n                flex-wrap: wrap;\n\n                ul {\n                    margin: 0px;\n                    margin-top: 10px !important;\n                    padding: 0px !important;\n                    list-style-type: none;\n                    display: flex;\n                    flex-wrap: wrap;\n                    background: transparent !important;\n\n                    li {\n                        padding: 10px;\n                        background: rgb(94, 161, 216) !important;\n                        border-radius: 10px;\n                        border: 1px solid #ddd;\n                        margin: 0px;\n                        margin-right: 5px;\n\n                        a {\n                            color: #fff !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .chatbot-btn {\n        width: 100%;\n        // height: 98%;\n        cursor: pointer;\n        margin-bottom: 0px;\n        padding: 0px 0px 0px 20px;\n        display: flex;\n        align-items: end;\n        justify-content: flex-end;\n        flex: 1;\n        margin-bottom: 10px;\n\n        img {\n            width: 80px;\n        }\n    }\n\n    .chatbot-converasation {\n        margin-bottom: 20px;\n        padding: 0px 20px;\n        width: 100%;\n\n        .chat-user,\n        .new-user {\n            max-width: 75%;\n            padding: 10px 10px;\n            background: #f6f6f6;\n            display: inline-flex;\n            justify-content: flex-start;\n            margin-bottom: 20px;\n            align-items: flex-start;\n            position: relative;\n            margin-left: 35px;\n            border-radius: 5px;\n            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);\n\n            p {\n                margin: 0px !important;\n            }\n\n            &:before {\n                content: \"\";\n                background: url(\"../../../assets/icons/chat-bot.png\");\n                // background: url(\"../../../assets/princess-light-skin-tone.png\");\n                background-repeat: no-repeat;\n                background-size: contain;\n                width: 30px;\n                height: 30px;\n                position: absolute;\n                left: -35px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n        }\n\n        .new-user {\n            display: flex;\n            justify-content: flex-end;\n            float: right;\n\n            &:before {\n                display: none;\n            }\n        }\n    }\n\n    .chatbot-stickyfooter {\n        width: 100%;\n        position: sticky;\n        bottom: 0px;\n        padding: 5px 20px;\n        background: #5ea1d8;\n        display: flex;\n        height: 50px;\n\n        .input {\n            position: relative;\n            height: 40px;\n            display: flex;\n            align-items: center;\n            flex: 1;\n            margin-right: 10px;\n\n            input {\n                width: 100%;\n                border: 1px solid #000;\n                border-radius: 10px;\n                display: flex;\n                align-items: center;\n                justify-content: flex-start;\n                position: absolute;\n                left: 0px;\n                height: 40px;\n                border: 0px;\n                padding-left: 30px;\n                outline: none !important;\n            }\n\n            i {\n                position: absolute;\n                z-index: 2;\n                // left: 6px;\n            }\n        }\n\n        .mic {\n            width: 40px;\n            height: 100%;\n            background: #fff;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n}\n\n.scroll-div {\n    // height: calc(400px - 72px);\n    // height: 229px;\n    // height: 100%;\n    // height: calc(100% - 104px - 50px);\n    min-height: 224px !important;\n    overflow-y: scroll;\n    padding-bottom: 0px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    // display: inline-block;\n    // justify-content: flex-end;\n}\n\n.sticky-chat {\n    position: sticky;\n    top: -20px;\n    z-index: 1000;\n    // background-color: rgb(94, 161, 216);\n    // border-bottom: 2px solid #ccc;\n    padding: 10px;\n    width: 100%;\n    height: 104px;\n}\n\n.sticky-default {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    z-index: 10000;\n\n    // width: 100px;\n    // height: auto;\n    img {\n        width: 80px;\n    }\n\n}\n\n.chatbot-msg {\n    height: 104px;\n}\n\n.scroll-div {\n    max-height: 425px;\n\n    .chatbot-msg {\n        // height: 100%;\n        height: auto !important;\n    }\n\n    .faq-list {\n        padding: 0px 20px;\n    }\n}\n\n@media (max-width: 767px) {\n    .chatbot-wrapper {\n        position: fixed;\n        bottom: 0px;\n        right: 0px;\n        padding: 20px;\n        display: flex;\n        padding: 20px 0px 0px;\n        background: #fff;\n        border: 1px solid #ddd;\n        box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n        margin: 0px 20px 0px 20px;\n        border-radius: 10px 10px 0px 0px;\n        max-width: 100%;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: 1000;\n        flex-wrap: wrap;\n        max-height: 90vh;\n        /* Limits max height but allows it to expand */\n        overflow-y: auto;\n        /* Enables scrolling when needed */\n        flex-direction: row;\n        left: 0px;\n        margin: 0px auto;\n    }\n}\n\n\n.flow-container {\n    display: flex;\n    gap: 20px;\n}\n\n/* Left: Expansion Panel */\n.steps-panel {\n    width: 100%;\n    // border-right: 2px solid #ddd;\n    // padding-right: 10px;\n}\n\nmat-expansion-panel {\n    background: #f8f9fa;\n    margin-bottom: 5px;\n}\n\nmat-expansion-panel-header {\n    font-weight: bold;\n    // background-color: #5ea1d8;;\n    color: white;\n    cursor: pointer;\n}\n\nmat-expansion-panel-header:hover {\n    // background-color: #5ea1d8;\n    background-color: rgba(200, 193, 193, 0.5);\n}\n\n/* Right: Step Content */\n.step-content {\n    width: 100%;\n    padding-left: 10px;\n}\n\n.step-content h3 {\n    margin-bottom: 10px;\n}\n\n.step-content video,\n.step-content img {\n    display: block;\n    margin-top: 10px;\n    border-radius: 5px;\n}\n\n.viewflow-step {\n    .flow-container {\n        width: 100%;\n    }\n\n    .description {\n        width: 100%;\n    }\n}\n\n.step-scroll {\n    overflow-x: auto; // Ensures horizontal scrolling\n    white-space: nowrap; // Prevents wrapping\n    width: 100%;\n    display: flex; // Ensures the inner content aligns properly\n}\n\n.steps-list {\n    display: flex;\n    gap: 5px; // Maintain spacing between buttons\n    margin-bottom: 10px;\n\n    button {\n        white-space: nowrap; // Prevents button text from wrapping\n        margin-bottom: 10px !important;\n    }\n}\n\n.group-header {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    /* Space between icon and text */\n    margin-top: 10px;\n    margin-left: 7px;\n    margin-right: 346px;\n    // color: #5ea1d8 !important;\n}\n\n.keyword-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n\n\n    &.less {\n        span {\n            flex: unset !important;\n\n            &:nth-child(n + 5) {\n                display: none;\n            }\n\n            &:nth-last-child(-n+2) {\n                display: inline;\n            }\n        }\n\n        .less-btn {\n            display: none !important;\n            width: 100% !important;\n            flex: unset !important;\n        }\n    }\n\n    &.more {\n        span {\n            flex: unset !important;\n\n            &:nth-child(n + 5) {\n\n                display: inline;\n            }\n\n            &:nth-last-child(-n+2) {\n                display: inline;\n            }\n        }\n\n        .more-btn {\n            display: none !important;\n            width: 100% !important;\n            flex: unset !important;\n        }\n    }\n}\n\n.more-btn,\n.less-btn {\n    // display: none !important;\n    width: 100% !important;\n    flex: unset !important;\n    justify-content: flex-start !important;\n}\n\nspan.showmore {\n    display: flex !important;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n}\n\n.hashtag {\n    font-family: 'Montserrat', sans-serif !important;\n    font-size: 12px;\n    font-weight: bold;\n    color: #5ea1d8;\n    padding: 2px 6px;\n    /* Reduced padding */\n    border-radius: 12px;\n    /* Optional: Makes it look like a pill */\n    background: rgba(94, 161, 216, 0.1);\n    /* Light background for visibility */\n    display: inline-block;\n    margin: 2px;\n    /* Minimal spacing between hashtags */\n}\n\n.more-btn,\n.less-btn {\n    font-size: 12px;\n    color: #888;\n    cursor: pointer;\n    margin-left: 4px;\n    /* Ensures it stays close to last hashtag */\n}\n\n\n.carousel {\n    width: 300px;\n    height: 200px;\n    background-color: #e0e0e0;\n    border-radius: 8px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    user-select: none;\n}\n\n.slide {\n    padding: 20px;\n    font-weight: bold;\n}\n\n.step-header {\n    display: flex;\n    align-items: center;\n    /* Vertically center all elements */\n    gap: 8px;\n    /* Space between elements */\n    width: 100%;\n\n    .s-num {\n        margin-bottom: 0px !important;\n    }\n\n    .share-icon {\n        align-items: center !important;\n    }\n\n}\n\n.s-num {\n    font-size: 16px;\n    /* Adjust size as needed */\n    font-weight: bold;\n    /* Optional: make step number stand out */\n    padding: 4px 8px;\n    /* Optional: padding for better appearance */\n}\n\n\n.share-icon {\n    font-size: 16px;\n    /* Match font size for consistency */\n    cursor: pointer;\n    /* Indicate clickability */\n    margin-left: auto;\n    /* Push icon to the right */\n}\n\nmat-panel-title {\n    display: flex;\n    align-items: center;\n    /* Vertically center elements */\n    justify-content: space-between;\n    /* Push share icon to the right */\n    width: 100%;\n    /* Ensure full width */\n    margin-top: 10px;\n}\n\n.step-info {\n    margin-top: 5px !important;\n    display: flex;\n    align-items: center;\n    align-items: flex-start;\n    /* Align content to the left */\n    gap: 8px;\n    /* Space between step number and title */\n    // flex-direction: column; /* Stack children vertically */\n}\n\n.step-number {\n    font-size: 16px;\n    /* Adjust as needed */\n    font-weight: bold;\n    /* Optional: emphasize step number */\n}\n\n.step-title {\n    font-size: 16px;\n    /* Match your h3 or desired size */\n    flex-grow: 1;\n    /* Allow title to take available space */\n    white-space: normal;\n    /* Allow title to wrap to the next line */\n    display: block;\n    /* Ensure it takes the full width and moves to the next line */\n}\n\n.share-icon {\n    font-size: 16px;\n    /* Match text size */\n    cursor: pointer;\n    /* Indicate clickability */\n    vertical-align: middle;\n    /* Align with text */\n}\n\nmat-expansion-panel-header {\n    min-height: 48px;\n    /* Default height, but allows growing */\n    height: auto;\n    /* Allow dynamic height based on content */\n    align-items: flex-start;\n    /* Align content to the top for better wrapping */\n    padding: 0 16px;\n    /* Adjust padding if needed (default Material padding) */\n}\n\n/* Override mat-expansion-panel-header for both collapsed and expanded states */\n:host ::ng-deep mat-expansion-panel-header {\n    min-height: 48px;\n    /* Default height, but allows growing */\n    height: auto;\n    /* Dynamic height based on content */\n    align-items: flex-start;\n    /* Align content to the top */\n    padding: 0 16px;\n    /* Default Material padding, adjust if needed */\n}\n\n/* Ensure expanded state also respects dynamic height */\n:host ::ng-deep .mat-expansion-panel-header.mat-expanded {\n    min-height: 48px;\n    /* Allow growing in expanded state */\n    height: auto;\n    /* Dynamic height */\n    align-items: flex-start;\n    /* Align content to the top */\n}\n\n.close-ico {\n    position: absolute;\n    top: 15px;\n    right: 25px;\n    color: white;\n    opacity: 1 !important;\n    z-index: 10;\n    position: fixed;\n    top: unset;\n    right: unset;\n    max-width: 360px;\n    width: 100%;\n    margin: 0px auto;\n    left: 0px;\n    right: 0px;\n    text-align: right;\n}\n\n.close-ico .fal {\n    font-size: 25px;\n    padding-right: 15px;\n    padding-top: 5px;\n}\n\n.btn-wrap {\n    height: 35px;\n    font-size: 14px;\n    cursor: pointer;\n    color: white;\n    background-color: #5ea1d8;\n    border-radius: 5px;\n}\n\n/* (Removed dialog-specific overrides for flow-layout, flow-info-panel, etc.\n   to let viewflow.component.scss define the exact mobile layout styles.) */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
